import { AssetTranslations } from './keys/asset.translate';
import { AssetTransactionTranslations } from './keys/assetTransaction.translate';
import { BarcodeExportConfigurationTranslations } from './keys/barcodeExportConfiguration.translate';
import { BinTranslations } from './keys/bin.translate';
import { BinConstraintTranslations } from './keys/binConstraint.translate';
import { CommonTranslations } from './keys/common.translate';
import { ContactTranslations } from './keys/contact.translate';
import { ContainerTranslations } from './keys/container.translate';
import { CustomFieldTranslations } from './keys/customField.translate';
import { FeatureToggleTranslations } from './keys/featureToggle.translate';
import { LotTranslations } from './keys/lot.translate';
import { OrderTranslations } from './keys/order.translate';
import { PdfTemplateTranslations } from './keys/pdfTemplate.translation';
import { ProductTranslations } from './keys/product.translate';
import { ProductMasterDataTranslations } from './keys/productMasterData.translate';
import { ProductTransactionTranslations } from './keys/productTransaction.translate';
import { ProfileTranslations } from './keys/profile.translate';
import { ScanTranslations } from './keys/scan.translate';
import { SortTranslations } from './keys/sorting.translate';
import { StockLocationTranslations } from './keys/stockLocation.translate';
import { TaskSettingsTranslations } from './keys/taskSettings.translate';
import { TableSettingsTranslations } from './keys/tableSettings.translate';
import { AuthorizationTranslations } from './keys/authorization.translation';
import { TriggerTranslations } from './keys/trigger.translate';
import { StockTriggerTranslations } from './keys/stockTrigger.translate';
import { ActionTranslations } from './keys/actions.translate';
import { KitTranslations } from './keys/kit.translate';
import { ReorderRuleTranslations } from './keys/reorderRule.translate';

export const TranslationKey = {
  ...ProductTranslations.common,
  ...ProductTranslations.error,
  ...ProductTranslations.exportConfigurations,

  ...BinTranslations.common,
  ...BinTranslations.error,

  ...ProductMasterDataTranslations.common,
  ...ProductMasterDataTranslations.error,
  ...ProductMasterDataTranslations.importConfigurations,
  ...ProductMasterDataTranslations.exportConfigurations,

  ...ProductTransactionTranslations.common,
  ...ProductTransactionTranslations.error,
  ...ProductTransactionTranslations.exportConfigurations,

  ...OrderTranslations.common,
  ...OrderTranslations.error,
  ...OrderTranslations.orders,

  ...ContainerTranslations.common,
  ...ContainerTranslations.error,

  ...LotTranslations.common,
  ...LotTranslations.error,

  ...StockLocationTranslations.common,
  ...StockLocationTranslations.error,

  ...ContactTranslations.common,
  ...ContactTranslations.error,

  ...BarcodeExportConfigurationTranslations.common,
  ...BarcodeExportConfigurationTranslations.error,
  ...BarcodeExportConfigurationTranslations.exportConfigurations,
  ...BarcodeExportConfigurationTranslations.barcodeFormats,

  ...BinConstraintTranslations.common,
  ...BinConstraintTranslations.error,
  ...BinConstraintTranslations.filter,
  ...BinConstraintTranslations.compontents,

  ...FeatureToggleTranslations.products,
  ...FeatureToggleTranslations.order,
  ...FeatureToggleTranslations.productTransaction,

  ...AssetTranslations.common,
  ...AssetTranslations.error,
  ...AssetTranslations.exportConfigurations,

  ...AssetTransactionTranslations.common,
  ...AssetTransactionTranslations.error,
  ...AssetTransactionTranslations.components,

  ...CommonTranslations.common,
  ...CommonTranslations.internal,
  ...CommonTranslations.upload,

  ...PdfTemplateTranslations.common,
  ...PdfTemplateTranslations.error,
  ...PdfTemplateTranslations.toast,

  ...SortTranslations.sorting,

  ...CustomFieldTranslations.customField,
  ...CustomFieldTranslations.error,

  ...TaskSettingsTranslations.components,

  ...ScanTranslations.toasts,

  ...ProfileTranslations.locale,
  ...ProfileTranslations.changePassword,

  ...TableSettingsTranslations.common,
  ...TableSettingsTranslations.productReference,
  ...TableSettingsTranslations.product,
  ...TableSettingsTranslations.order,
  ...TableSettingsTranslations.asset,
  ...TableSettingsTranslations.container,
  ...TableSettingsTranslations.error,

  ...AuthorizationTranslations.error,

  ...StockTriggerTranslations.parse,
  ...TriggerTranslations.lots,

  ...ActionTranslations.common,

  ...KitTranslations.common,
  ...ReorderRuleTranslations.error,

  accept: 'accept',
  acceptedFormats: 'acceptedFormats',
  actions: 'actions',
  add: 'add',
  addAdditionalOrderExportField: 'addAdditionalOrderExportField',
  addAdditionalProductExportField: 'addAdditionalProductExportField',
  addAdditionalTaskExportField: 'addAdditionalTaskExportField',
  addDueDate: 'addDueDate',
  addManually: 'addManually',
  addFilter: 'addFilter',
  additionalProductIdentificationAssignedByTheManufacturer: 'additionalProductIdentificationAssignedByTheManufacturer',
  additionalSettings: 'additionalSettings',
  addProduct: 'addProduct',
  addProductsToOrder: 'addProductsToOrder',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  administrator: 'administrator',
  advancedSettings: 'advancedSettings',
  alert: 'alert',
  alertsAlertFeatureToggle: 'alertsAlertFeatureToggle',
  all: 'all',
  allOf: 'allOf',
  alreadyHaveAccountQuestion: 'alreadyHaveAccountQuestion',
  anAlertHasBeenTriggeredText: 'anAlertHasBeenTriggeredText',
  any: 'any',
  anyOf: 'anyOf',
  apiKey: 'apiKey',
  apiKeyForUserAlreadyExistsWithinCompany: 'apiKeyForUserAlreadyExistsWithinCompany',
  applicationPartIncident: 'applicationPartIncident',
  appliesToAllProducts: 'appliesToAllProducts',
  attachements: 'attachements',
  attributes: 'attributes',
  authentication: 'authentication',
  authenticationCodeForUserAlreadyExists: 'authenticationCodeForUserAlreadyExists',
  authenticationCodeHasExpired: 'authenticationCodeHasExpired',
  authenticationSettingsForUserAlreadyExists: 'authenticationSettingsForUserAlreadyExists',
  authenticationType: 'authenticationType',
  back: 'back',
  barcode: 'barcode',
  barcodeConfigurations: 'barcodeConfigurations',
  barcodeConfigurationType: 'barcodeConfigurationType',
  barcodeFormat: 'barcodeFormat',
  bestBeforeDate: 'bestBeforeDate',
  billing: 'billing',
  billToInvoiceToGlobalLocationNumber: 'billToInvoiceToGlobalLocationNumber',
  bin: 'bin',
  binHasNoStockLocation: 'binHasNoStockLocation',
  binMetrics: 'binMetrics',
  binName: 'binName',
  binStatus: 'binStatus',
  binStatusWithNameAlreadyExists: 'binStatusWithNameAlreadyExists',
  binWithNameAlreadyExists: 'binWithNameAlreadyExists',
  binWithNameAlreadyExistsForStockLocation: 'binWithNameAlreadyExistsForStockLocation',
  blindCount: 'blindCount',
  browse: 'browse',
  businessCentralUnableToDetermineSourceStockLocation: 'businessCentralUnableToDetermineSourceStockLocation',
  businessCentralUnableToFindIdentifierToCreateJournalEntry:
    'businessCentralUnableToFindIdentifierToCreateJournalEntry',
  businessCentralUnableToFindParentOrder: 'businessCentralUnableToFindParentOrder',
  businessCentralUnableToFindProjektasKodas: 'businessCentralUnableToFindProjektasKodas',
  businessCentralUnableToFindProjektasKodasValue: 'businessCentralUnableToFindProjektasKodasValue',
  businessCentralUnableToProcessWhenStockLocationIsNot: 'businessCentralUnableToProcessWhenStockLocationIsNot',
  businessCentralUnableToUpdateTransactions: 'businessCentralUnableToUpdateTransactions',
  cancel: 'cancel',
  cancelled: 'cancelled',
  cancelOrder: 'cancelOrder',
  cancelOrderValidation: 'cancelOrderValidation',
  cancelTransaction: 'cancelTransaction',
  cannotAssignUserNotAssignedToStockLocation: 'cannotAssignUserNotAssignedToStockLocation',
  cannotAssignUserWithoutRoleInCompany: 'cannotAssignUserWithoutRoleInCompany',
  cannotCreateTaskWithoutDueDate: 'cannotCreateTaskWithoutDueDate',
  cannotDeleteExistingProductsIfStockLocationNotUndefined: 'cannotDeleteExistingProductsIfStockLocationNotUndefined',
  cellularMobileTelephoneIdentifier: 'cellularMobileTelephoneIdentifier',
  city: 'city',
  clearAll: 'clearAll',
  clickToSelectAndDisplayProductImage: 'clickToSelectAndDisplayProductImage',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  cm: 'cm',
  code: 'code',
  collapse: 'collapse',
  color: 'color',
  comment: 'comment',
  company: 'company',
  companyAlreadyHasSubscription: 'companyAlreadyHasSubscription',
  companyColors: 'companyColors',
  companyDoesNotHaveAnyStockLocations: 'companyDoesNotHaveAnyStockLocations',
  companyFavicon: 'companyFavicon',
  companyInternalInformation: 'companyInternalInformation',
  companyLevel: 'companyLevel',
  companyLogo: 'companyLogo',
  companyName: 'companyName',
  complete: 'complete',
  completed: 'completed',
  completedOn: 'completedOn',
  completeOrder: 'completeOrder',
  completeOrderValidation: 'completeOrderValidation',
  componentPartIdentifier: 'componentPartIdentifier',
  componentPartIdentifierSerialNumber: 'componentPartIdentifierSerialNumber',
  confirm: 'confirm',
  confirmPassword: 'confirmPassword',
  consumerProductVariant: 'consumerProductVariant',
  contact: 'contact',
  contactEmail: 'contactEmail',
  contactLocationWithNameXNotPartOfContactY: 'contactLocationWithNameXNotPartOfContactY',
  contacts: 'contacts',
  contactWithNameAlreadyExists: 'contactWithNameAlreadyExists',
  contactWithNameXNotFound: 'contactWithNameXNotFound',
  countedOnly: 'countedOnly',
  countOfTradeItemsContained: 'countOfTradeItemsContained',
  country: 'country',
  countryCoveringFullProcessChain: 'countryCoveringFullProcessChain',
  countryOfDisassembly: 'countryOfDisassembly',
  countryOfInitialProcessing: 'countryOfInitialProcessing',
  countryOfOrigin: 'countryOfOrigin',
  countryOfOriginOfTradeItem: 'countryOfOriginOfTradeItem',
  countryOfProcessing: 'countryOfProcessing',
  couponCodeIdentificationNorthAmerica: 'couponCodeIdentificationNorthAmerica',
  create: 'create',
  createBarcodeConfiguration: 'createBarcodeConfiguration',
  createBin: 'createBin',
  createBinStatus: 'createBinStatus',
  createCompany: 'createCompany',
  createContact: 'createContact',
  createCustomField: 'createCustomField',
  created: 'created',
  createdAt: 'createdAt',
  createdBy: 'createdBy',
  createDemoCompany: 'createDemoCompany',
  createIntegration: 'createIntegration',
  createNewCompany: 'createNewCompany',
  createOrder: 'createOrder',
  createProductMasterData: 'createProductMasterData',
  createReplenishOrderAuto: 'createReplenishOrderAuto',
  createScanRule: 'createScanRule',
  createShippingLocation: 'createShippingLocation',
  createStockLocation: 'createStockLocation',
  createStockLocationRole: 'createStockLocationRole',
  createSuperUser: 'createSuperUser',
  createTask: 'createTask',
  createTrigger: 'createTrigger',
  creatingInboundOrdersNotAllowedForElteros: 'creatingInboundOrdersNotAllowedForElteros',
  csvUploadConfigurationNamePlaceholder: 'csvUploadConfigurationNamePlaceholder',
  currency: 'currency',
  currentMonth: 'currentMonth',
  customer: 'customer',
  customerPartNumber: 'customerPartNumber',
  customerPurchaseOrderNumber: 'customerPurchaseOrderNumber',
  customFieldIsRequiredForProductTransactions: 'customFieldIsRequiredForProductTransactions',
  customFieldRequiesEntityParentType: 'customFieldRequiesEntityParentType',
  customFieldRequiresEntitySubtype: 'customFieldRequiresEntitySubtype',
  customFields: 'customFields',
  customFieldWithIdNotFound: 'customFieldWithIdNotFound',
  customFieldWithNameAlreadyExists: 'customFieldWithNameAlreadyExists',
  customFieldXUsedForValidationButDoesNotMatch: 'customFieldXUsedForValidationButDoesNotMatch',
  customValue: 'customValue',
  cycleCount: 'cycleCount',
  dashboard: 'dashboard',
  dateAndTime: 'dateAndTime',
  dateAndTimeOfProduction: 'dateAndTimeOfProduction',
  dateInFuture: 'dateInFuture',
  dateInPast: 'dateInPast',
  day: 'day',
  decline: 'decline',
  defaultAsText: 'defaultAsText',
  defaultValue: 'defaultValue',
  delete: 'delete',
  deleteAllExistingBins: 'deleteAllExistingBins',
  delimiter: 'delimiter',
  depth: 'depth',
  destinationBin: 'destinationBin',
  destinationNumber: 'destinationNumber',
  destinationStockLocation: 'destinationStockLocation',
  developerOptions: 'developerOptions',
  discrepancyOnly: 'discrepancyOnly',
  discrepancyThreshold: 'discrepancyThreshold',
  dm: 'dm',
  done: 'done',
  downloadTemplate: 'downloadTemplate',
  due: 'due',
  dueDate: 'dueDate',
  dueDateMandatory: 'dueDateMandatory',
  duplicateFile: 'duplicateFile',
  duplicateLPNFoundOnRows: 'duplicateLPNFoundOnRows',
  edit: 'edit',
  email: 'email',
  employee: 'employee',
  entitiesNotFound: 'entitiesNotFound',
  entityAlreadyExistsInDatabase: 'entityAlreadyExistsInDatabase',
  entityAlreadyUpdatedInTheDatabase: 'entityAlreadyUpdatedInTheDatabase',
  entityNotFound: 'entityNotFound',
  entityParentType: 'entityParentType',
  entitySubtype: 'entitySubtype',
  entityType: 'entityType',
  entityXNotFound: 'entityXNotFound',
  environment: 'environment',
  estimatedTimeOfArrival: 'estimatedTimeOfArrival',
  expectedQuantity: 'expectedQuantity',
  expirationDate: 'expirationDate',
  expirationDateAndTime: 'expirationDateAndTime',
  expiryInHours: 'expiryInHours',
  export: 'export',
  exportOrders: 'exportOrders',
  exportProductReferences: 'exportProductReferences',
  exportProducts: 'exportProducts',
  exportProductTransactions: 'exportProductTransactions',
  externalId: 'externalId',
  externalReference: 'externalReference',
  externalReferenceId: 'externalReferenceId',
  featureCategory: 'featureCategory',
  featureToggles: 'featureToggles',
  field: 'field',
  fieldUser: 'fieldUser',
  fileFormatCsv: 'fileFormatCsv',
  fileName: 'fileName',
  filesAndAssets: 'filesAndAssets',
  filterAlerts: 'filterAlerts',
  filterBarcodeConfigurations: 'filterBarcodeConfigurations',
  filterBins: 'filterBins',
  filterBinStatus: 'filterBinStatus',
  filterContacts: 'filterContacts',
  filterCountries: 'filterCountries',
  filterCustomFields: 'filterCustomFields',
  fileExistsToastErrorMessage: 'fileExistsToastErrorMessage',
  filterFiles: 'filterFiles',
  filterIntegrations: 'filterIntegrations',
  filterOrders: 'filterOrders',
  filterOrderStatus: 'filterOrderStatus',
  filterProductReferenceData: 'filterProductReferenceData',
  filterProducts: 'filterProducts',
  filterProductTransactions: 'filterProductTransactions',
  filterReorderRules: 'filterReorderRules',
  filters: 'filters',
  filterScanRules: 'filterScanRules',
  filterSerials: 'filterSerials',
  filterShippingLocations: 'filterShippingLocations',
  filterStockLocations: 'filterStockLocations',
  filterTasks: 'filterTasks',
  filterTaskStatus: 'filterTaskStatus',
  filterTriggers: 'filterTriggers',
  filterUsers: 'filterUsers',
  finish: 'finish',
  firstName: 'firstName',
  forMoreInformationVisitLink: 'forMoreInformationVisitLink',
  forgotPassword: 'forgotPassword',
  forTheFollowingStockLocations: 'forTheFollowingStockLocations',
  foundTwoDifferentValuesForSameCustomFieldPropertyForOrderXOnRowY:
    'foundTwoDifferentValuesForSameCustomFieldPropertyForOrderXOnRowY',
  foundTwoDifferentValuesForSamePropertyForOrderXOnRowY: 'foundTwoDifferentValuesForSamePropertyForOrderXOnRowY',
  g: 'g',
  general: 'general',
  generateApiKey: 'generateApiKey',
  globalCouponNumber: 'globalCouponNumber',
  globalDocumentTypeIdentifier: 'globalDocumentTypeIdentifier',
  globalIdentifierNumberForConsignment: 'globalIdentifierNumberForConsignment',
  globalIndividualAssetIdentifier: 'globalIndividualAssetIdentifier',
  globalLocationNumber: 'globalLocationNumber',
  globalLocationNumberExtensionComponent: 'globalLocationNumberExtensionComponent',
  globalLocationNumberInvoicingParty: 'globalLocationNumberInvoicingParty',
  globalModelNumber: 'globalModelNumber',
  globalReturnableAssetIdentifier: 'globalReturnableAssetIdentifier',
  globalServiceRelationNumberProvider: 'globalServiceRelationNumberProvider',
  globalServiceRelationNumberRecipient: 'globalServiceRelationNumberRecipient',
  globalShipmentIdentificationNumber: 'globalShipmentIdentificationNumber',
  globalTradeItemNumber: 'globalTradeItemNumber',
  globalTradeItemNumberOfTradeItemsContained: 'globalTradeItemNumberOfTradeItemsContained',
  grossWeight: 'grossWeight',
  headerBackground: 'headerBackground',
  height: 'height',
  hexColorCode: 'hexColorCode',
  history: 'history',
  hour: 'hour',
  identificationOfIndividualTradeItem: 'identificationOfIndividualTradeItem',
  ignoreAvailableQuantity: 'ignoreAvailableQuantity',
  implementMe: 'implementMe',
  import: 'import',
  importance: 'importance',
  importBins: 'importBins',
  importConfigurations: 'importConfigurations',
  importOrders: 'importOrders',
  importProduct: 'importProduct',
  importProductMasterData: 'importProductMasterData',
  importStockLocations: 'importStockLocations',
  importUsers: 'importUsers',
  inbound: 'inbound',
  inboundAllowed: 'inboundAllowed',
  inboundOrder: 'inboundOrder',
  incidentApplication: 'incidentApplication',
  incidentApplicationPart: 'incidentApplicationPart',
  incidentReportDescriptionMayNotBeEmptyOrUndefined: 'incidentReportDescriptionMayNotBeEmptyOrUndefined',
  incidentReportDeviceMayNotBeEmptyOrUndefinedIfApplicationMobile:
    'incidentReportDeviceMayNotBeEmptyOrUndefinedIfApplicationMobile',
  incidentReportMobileElementMustBeSelectedIfApplicationMobile:
    'incidentReportMobileElementMustBeSelectedIfApplicationMobile',
  incidentReportOperatingSystemMayNotBeEmptyOrUndefinedIfApplicationMobile:
    'incidentReportOperatingSystemMayNotBeEmptyOrUndefinedIfApplicationMobile',
  incidentReportWebElementMustBeSelectedIfApplicationWeb: 'incidentReportWebElementMustBeSelectedIfApplicationWeb',
  incorrectCode: 'incorrectCode',
  info: 'info',
  informationMutuallyAgreedBetweenTradingPartners: 'informationMutuallyAgreedBetweenTradingPartners',
  inProgress: 'inProgress',
  insufficientQuantityAvailableInBin: 'insufficientQuantityAvailableInBin',
  integrations: 'integrations',
  internalProductVariant: 'internalProductVariant',
  internationalBankAccountNumber: 'internationalBankAccountNumber',
  invalidDate: 'invalidDate',
  invalidOrderStatusOnRowX: 'invalidOrderStatusOnRowX',
  invalidOrderTypeOnRowX: 'invalidOrderTypeOnRowX',
  invalidQuantity: 'invalidQuantity',
  invalidQuantityX: 'invalidQuantityX',
  invalidTriggerEntityValueText: 'invalidTriggerEntityValueText',
  invite: 'invite',
  inviteUser: 'inviteUser',
  isToday: 'isToday',
  isTomorrow: 'isTomorrow',
  isYesterday: 'isYesterday',
  itemDoesNotHaveProperty: 'itemDoesNotHaveProperty',
  jobForStockLocationIdentifierIsNotOpen: 'jobForStockLocationIdentifierIsNotOpen',
  jobForTransactionIsNotOpen: 'jobForTransactionIsNotOpen',
  kg: 'kg',
  language: 'language',
  lastmonth: 'lastmonth',
  lastName: 'lastName',
  lastweek: 'lastweek',
  lb: 'lb',
  length: 'length',
  location: 'location',
  locations: 'locations',
  lotHasExpiredAlertText: 'lotHasExpiredAlertText',
  lotManaged: 'lotManaged',
  lotNumber: 'lotNumber',
  lotTriggerValueText: 'lotTriggerValueText',
  lotWillExpireAlertText: 'lotWillExpireAlertText',
  lotWithNumberAlreadyExistsForProductReference: 'lotWithNumberAlreadyExistsForProductReference',
  lpn: 'lpn',
  lpnManaged: 'lpnManaged',
  m: 'm',
  madeToOrderVariationNumber: 'madeToOrderVariationNumber',
  manager: 'manager',
  mandatory: 'mandatory',
  manufacturer: 'manufacturer',
  manufacturerCode: 'manufacturerCode',
  manyAlertsHaveBeenTriggeredText: 'manyAlertsHaveBeenTriggeredText',
  map: 'map',
  mapTheFollowingFields: 'mapTheFollowingFields',
  mapUnavailable: 'mapUnavailable',
  mass: 'mass',
  max: 'max',
  missingMandatoryCustomFieldXOnRowY: 'missingMandatoryCustomFieldXOnRowY',
  missingRequiredFieldMapping: 'missingRequiredFieldMapping',
  missingValueForRequiredCustomFieldX: 'missingValueForRequiredCustomFieldX',
  mm: 'mm',
  mobileStockLocation: 'mobileStockLocation',
  mustSelectAtLeastOneStockLocationRoleForInitialCount: 'mustSelectAtLeastOneStockLocationRoleForInitialCount',
  mustSelectAtLeastOneStockLocationRoleForRecountIfDiscrepancyThresholdIsHigherThan0:
    'mustSelectAtLeastOneStockLocationRoleForRecountIfDiscrepancyThresholdIsHigherThan0',
  name: 'name',
  natoStockNumber: 'natoStockNumber',
  netWeight: 'netWeight',
  networkConnection: 'networkConnection',
  networkConnectionOccurrence: 'networkConnectionOccurrence',
  newAsText: 'newAsText',
  newComment: 'newComment',
  next: 'next',
  no: 'no',
  noAccountYetQuestion: 'noAccountYetQuestion',
  noAddress: 'noAddress',
  noCompaniesFound: 'noCompaniesFound',
  noItemsFound: 'noItemsFound',
  noJobsFound: 'noJobsFound',
  noLinesFoundForPurchaseOrder: 'noLinesFoundForPurchaseOrder',
  noLocationsFound: 'noLocationsFound',
  noProductReferenceFound: 'noProductReferenceFound',
  noPurchaseOrdersFound: 'noPurchaseOrdersFound',
  noSettingsFoundForBusinessCentral: 'noSettingsFoundForBusinessCentral',
  noStockLocationIdOrStockLocationMappingProvided: 'noStockLocationIdOrStockLocationMappingProvided',
  noStockLocationsGiven: 'noStockLocationsGiven',
  noValidTaskInputFound: 'noValidTaskInputFound',
  nrOfDigits: 'nrOfDigits',
  numberOfCounts: 'numberOfCounts',
  numberOfOrders: 'numberOfOrders',
  numberOfTransactions: 'numberOfTransactions',
  oldPassword: 'oldPassword',
  only1CustomFieldPerEntitySubtypeSupported: 'only1CustomFieldPerEntitySubtypeSupported',
  open: 'open',
  operatingSystemVersion: 'operatingSystemVersion',
  optionalPhoneNumber: 'optionalPhoneNumber',
  or: 'or',
  order: 'order',
  orderEditProductsOnInbound: 'orderEditProductsOnInbound',
  orderEditProductsOnOutbound: 'orderEditProductsOnOutbound',
  orderMetrics: 'orderMetrics',
  orderNumbers: 'orderNumbers',
  orderOrderFeatureToggle: 'orderOrderFeatureToggle',
  orderProductSelectionFirst: 'orderProductSelectionFirst',
  orderReportConfigurationWithNameAlreadyExists: 'orderReportConfigurationWithNameAlreadyExists',
  orderSettings: 'orderSettings',
  orderStatus: 'orderStatus',
  orderType: 'orderType',
  orderWithNumberXMissingMandatoryCustomFieldY: 'orderWithNumberXMissingMandatoryCustomFieldY',
  orderWithNumberXMissingStockLocationNameOrIdentifier: 'orderWithNumberXMissingStockLocationNameOrIdentifier',
  orderWithNumberXMissingType: 'orderWithNumberXMissingType',
  originalEquipmentManufacturer: 'originalEquipmentManufacturer',
  originalEquipmentManufacturerCode: 'originalEquipmentManufacturerCode',
  originalEquipmentManufacturerCodePlacehoder: 'originalEquipmentManufacturerCodePlacehoder',
  ourProduct: 'ourProduct',
  outbound: 'outbound',
  outboundAllowed: 'outboundAllowed',
  outboundOrder: 'outboundOrder',
  overdue: 'overdue',
  overview: 'overview',
  oz: 'oz',
  pack: 'pack',
  packagingDate: 'packagingDate',
  password: 'password',
  passwordRequirementInfo: 'passwordRequirementInfo',
  paymentSlipReferenceNumber: 'paymentSlipReferenceNumber',
  pleaseDefineDefaultBin: 'pleaseDefineDefaultBin',
  pleaseSelectConfigurationsForProductReferenceExport: 'pleaseSelectConfigurationsForProductReferenceExport',
  pmdQuantityAlertText: 'pmdQuantityAlertText',
  postalCode: 'postalCode',
  prefix: 'prefix',
  pricePerUnitOfMeasure: 'pricePerUnitOfMeasure',
  primarilyBenifitFeature: 'primarilyBenifitFeature',
  primaryColor: 'primaryColor',
  priority: 'priority',
  process: 'process',
  processed: 'processed',
  processedAt: 'processedAt',
  processedBy: 'processedBy',
  processedQuantityExceedsExpectedQuantity: 'processedQuantityExceedsExpectedQuantity',
  processQuantity: 'processQuantity',
  processTransaction: 'processTransaction',
  product: 'product',
  productAlreadyExists: 'productAlreadyExists',
  productImage: 'productImage',
  productImportExistingConfigurationPlaceholder: 'productImportExistingConfigurationPlaceholder',
  productionDate: 'productionDate',
  productMasterData: 'productMasterData',
  productMasterDataNotDefined: 'productMasterDataNotDefined',
  productMetrics: 'productMetrics',
  productName: 'productName',
  productNumber: 'productNumber',
  productReferenceData: 'productReferenceData',
  productReferenceWithNumberXNotFound: 'productReferenceWithNumberXNotFound',
  productReferenceWithProductNumberAlreadyExists: 'productReferenceWithProductNumberAlreadyExists',
  productReportConfigurationWithNameAlreadyExists: 'productReportConfigurationWithNameAlreadyExists',
  productsGS1Toggle: 'productsGS1Toggle',
  productsProductToggle: 'productsProductToggle',
  productTransaction: 'productTransaction',
  productTransactionAlertCustomFieldNotFoundText: 'productTransactionAlertCustomFieldNotFoundText',
  productTransactionAlertOrderText: 'productTransactionAlertOrderText',
  productTransactionAlertUnknownOrderText: 'productTransactionAlertUnknownOrderText',
  productTransactionDueDateAlertText: 'productTransactionDueDateAlertText',
  productTransactionDueDateTriggerText: 'productTransactionDueDateTriggerText',
  productTransactionFieldUpdatedAlertText: 'productTransactionFieldUpdatedAlertText',
  productTransactionReportConfigurationWithNameAlreadyExists:
    'productTransactionReportConfigurationWithNameAlreadyExists',
  productTransactionsMobile: 'productTransactionsMobile',
  productTransactionsProductTransactionFeatureToggle: 'productTransactionsProductTransactionFeatureToggle',
  productTransactionsQuickActions: 'productTransactionsQuickActions',
  productTransactionsWeb: 'productTransactionsWeb',
  productTransactionTriggerRequiresAtLeastOneCustomField: 'productTransactionTriggerRequiresAtLeastOneCustomField',
  productWithLPNAlreadyExists: 'productWithLPNAlreadyExists',
  productWIthLPNOnRowAlreadyExists: 'productWIthLPNOnRowAlreadyExists',
  productWithLPNOnRowAlreadyExistsInOtherStockLocation: 'productWithLPNOnRowAlreadyExistsInOtherStockLocation',
  productWithSerialAlreadyExists: 'productWithSerialAlreadyExists',
  productWithSerialOnRowAlreadyExists: 'productWithSerialOnRowAlreadyExists',
  profile: 'profile',
  purchasedFromGlobalLocationNumber: 'purchasedFromGlobalLocationNumber',
  purchaseOrderNumber: 'purchaseOrderNumber',
  purchasePrice: 'purchasePrice',
  pushNotification: 'pushNotification',
  quantity: 'quantity',
  raiseOnBehalfOf: 'raiseOnBehalfOf',
  reassignUsers: 'reassignUsers',
  recount: 'recount',
  referenceData: 'referenceData',
  referenceToSourceEntity: 'referenceToSourceEntity',
  refreshCompanyCache: 'refreshCompanyCache',
  region: 'region',
  released: 'released',
  reorderPoint: 'reorderPoint',
  reorderRuleForProduct: 'reorderRuleForProduct',
  reorderRuleForProductStockLocationAndAggregateTypeAlreadyExists:
    'reorderRuleForProductStockLocationAndAggregateTypeAlreadyExists',
  reorderUserRuleForProductAndStockLocationAlreadyExists: 'reorderUserRuleForProductAndStockLocationAlreadyExists',
  reorderUsers: 'reorderUsers',
  replenish: 'replenish',
  reportIncident: 'reportIncident',
  reporting: 'reporting',
  reportOnBehalfOf: 'reportOnBehalfOf',
  requestNewCode: 'requestNewCode',
  requestType: 'requestType',
  reset: 'reset',
  resetToDefault: 'resetToDefault',
  role: 'role',
  rolesForInitialCount: 'rolesForInitialCount',
  rolesForRecount: 'rolesForRecount',
  rollback: 'rollback',
  rollProducts: 'rollProducts',
  routingCode: 'routingCode',
  rowMustContainOrderNumber: 'rowMustContainOrderNumber',
  save: 'save',
  scan: 'scan',
  scanProduct: 'scanProduct',
  scanRules: 'scanRules',
  secondarySerialNumber: 'secondarySerialNumber',
  selectAll: 'selectAll',
  selectAnImage: 'selectAnImage',
  selectAProduct: 'selectAProduct',
  selectAssignedOrderUsers: 'selectAssignedOrderUsers',
  selectBinsOrProducts: 'selectBinsOrProducts',
  selectBinStatus: 'selectBinStatus',
  selectBinStatuses: 'selectBinStatuses',
  selectBinStatusesThatYouWantToExclude: 'selectBinStatusesThatYouWantToExclude',
  selectBinsThatYouWantToExclude: 'selectBinsThatYouWantToExclude',
  selectCompanyRolesThatShouldReceiveNotification: 'selectCompanyRolesThatShouldReceiveNotification',
  selectCsvUploadConfiguration: 'selectCsvUploadConfiguration',
  selectReportReceivers: 'selectReportReceivers',
  selectStockLocation: 'selectStockLocation',
  selectStockLocationRole: 'selectStockLocationRole',
  selectStockLocationRoles: 'selectStockLocationRoles',
  selectStockLocationRolesThatShouldReceiveNotification: 'selectStockLocationRolesThatShouldReceiveNotification',
  selectTaskAssignees: 'selectTaskAssignees',
  selectUsersThatShouldReceiveANotification: 'selectUsersThatShouldReceiveANotification',
  sellingPrice: 'sellingPrice',
  send: 'send',
  sendMailOnAssigned: 'sendMailOnAssigned',
  sendPushNotificationToAssignees: 'sendPushNotificationToAssignees',
  serial: 'serial',
  serialManaged: 'serialManaged',
  serialNumber: 'serialNumber',
  serialShippingContainerCode: 'serialShippingContainerCode',
  service: 'service',
  sessionStorageToggle: 'sessionStorageToggle',
  set: 'set',
  setCompanyRole: 'setCompanyRole',
  setDueDate: 'setDueDate',
  settings: 'settings',
  sevenDays: 'sevenDays',
  shipForDeliverForForwardToGlobalLocationNumber: 'shipForDeliverForForwardToGlobalLocationNumber',
  shipToDeliverISOcountryCode: 'shipToDeliverISOcountryCode',
  shipToDeliverToGlobalLocationNumber: 'shipToDeliverToGlobalLocationNumber',
  shipToDeliverToPostalCode: 'shipToDeliverToPostalCode',
  signIn: 'signIn',
  signOut: 'signOut',
  signUp: 'signUp',
  size: 'size',
  softwareVersion: 'softwareVersion',
  sourceBin: 'sourceBin',
  sourceNumber: 'sourceNumber',
  sourceStockLocation: 'sourceStockLocation',
  splitByOrder: 'splitByOrder',
  status: 'status',
  step: 'step',
  stock: 'stock',
  stockExportConfigurationSelectPlaceholder: 'stockExportConfigurationSelectPlaceholder',
  stockLocation: 'stockLocation',
  stockLocationAggregateTypeAllOfText: 'stockLocationAggregateTypeAllOfText',
  stockLocationAggregateTypeAllText: 'stockLocationAggregateTypeAllText',
  stockLocationAggregateTypeAnyOfText: 'stockLocationAggregateTypeAnyOfText',
  stockLocationAggregateTypeAnyText: 'stockLocationAggregateTypeAnyText',
  stockLocationCount: 'stockLocationCount',
  stockLocationIdentifier: 'stockLocationIdentifier',
  stockLocationLevel: 'stockLocationLevel',
  stockLocationMustBeDefinedToUploadBins: 'stockLocationMustBeDefinedToUploadBins',
  stockLocationName: 'stockLocationName',
  stockLocationRolesForInitialCountCannotBeStockLocationViewer:
    'stockLocationRolesForInitialCountCannotBeStockLocationViewer',
  stockLocationWithIdentifierOnRowDoesNotExist: 'stockLocationWithIdentifierOnRowDoesNotExist',
  stockLocationWithIdentifierXNotFound: 'stockLocationWithIdentifierXNotFound',
  stockLocationWithNameAlreadyExists: 'stockLocationWithNameAlreadyExists',
  stockLocationWithNameXNotFound: 'stockLocationWithNameXNotFound',
  stockTriggers: 'stockTriggers',
  submit: 'submit',
  submitIdea: 'submitIdea',
  suffix: 'suffix',
  superUserWithEmailAlreadyExists: 'superUserWithEmailAlreadyExists',
  superUserWithUserIdAlreadyExists: 'superUserWithUserIdAlreadyExists',
  supervisor: 'supervisor',
  supplier: 'supplier',
  support: 'support',
  supportedFilesCanBeImagesVideoOrDocuments: 'supportedFilesCanBeImagesVideoOrDocuments',
  syncAddress: 'syncAddress',
  syncItems: 'syncItems',
  syncJobs: 'syncJobs',
  syncJournals: 'syncJournals',
  syncLocations: 'syncLocations',
  syncPurchaseOrders: 'syncPurchaseOrders',
  tableSettings: 'tableSettings',
  tapToViewThemInAppNotificationBody: 'tapToViewThemInAppNotificationBody',
  targetUsers: 'targetUsers',
  taskDueDateAlertText: 'taskDueDateAlertText',
  taskDueDateTriggerValueText: 'taskDueDateTriggerValueText',
  taskMetrics: 'taskMetrics',
  taskNumbers: 'taskNumbers',
  taskReportConfigurationWithNameAlreadyExists: 'taskReportConfigurationWithNameAlreadyExists',
  taskSettingsAlreadyExistsForThisEntity: 'taskSettingsAlreadyExistsForThisEntity',
  tasksStockUpdateFeatureToggle: 'tasksStockUpdateFeatureToggle',
  tasksTaskFeatureToggle: 'tasksTaskFeatureToggle',
  taskStatus: 'taskStatus',
  taskType: 'taskType',
  tellUsMore: 'tellUsMore',
  tellUsMoreFeature: 'tellUsMoreFeature',
  tellUsMoreIncident: 'tellUsMoreIncident',
  tenantId: 'tenantId',
  thankYouForRegistering: 'thankYouForRegistering',
  theme: 'theme',
  thirtyDays: 'thirtyDays',
  thismonth: 'thismonth',
  thisweek: 'thisweek',
  threeMonths: 'threeMonths',
  today: 'today',
  tokenAlreadyExists: 'tokenAlreadyExists',
  tokenForUserAlreadyExists: 'tokenForUserAlreadyExists',
  total: 'total',
  transactionInfo: 'transactionInfo',
  transactions: 'transactions',
  triggerCondition: 'triggerCondition',
  triggerEntityIds: 'triggerEntityIds',
  triggerEntityType: 'triggerEntityType',
  triggerInvalidAmountOfCustomFieldsProvided: 'triggerInvalidAmountOfCustomFieldsProvided',
  triggers: 'triggers',
  triggerTypes: 'triggerTypes',
  triggerTypeText: 'triggerTypeText',
  triggerUserText: 'triggerUserText',
  triggerValueText: 'triggerValueText',
  twelveMonths: 'twelveMonths',
  type: 'type',
  unableToAddLPNToProductIfProductMasterDataNotLPNManaged: 'unableToAddLPNToProductIfProductMasterDataNotLPNManaged',
  unableToAddProductWithQuantityOnRow: 'unableToAddProductWithQuantityOnRow',
  unableToAddSerialOnProductIfProductMasterDataNotSerialManaged:
    'unableToAddSerialOnProductIfProductMasterDataNotSerialManaged',
  unableToAddUserWithInvalidCompanyRoleOnRowX: 'unableToAddUserWithInvalidCompanyRoleOnRowX',
  unableToAddUserWithoutEmailOnRowX: 'unableToAddUserWithoutEmailOnRowX',
  unableToCompleteOrderWithPendingItems: 'unableToCompleteOrderWithPendingItems',
  unableToCompleteTaskThatHasNotBeenStarted: 'unableToCompleteTaskThatHasNotBeenStarted',
  unableToCompleteTaskThatIsAlreadyCompleted: 'unableToCompleteTaskThatIsAlreadyCompleted',
  unableToCompleteTaskThatIsAlreadyProcessed: 'unableToCompleteTaskThatIsAlreadyProcessed',
  unableToCompleteTaskWhenThereAreProductsLeftToCount: 'unableToCompleteTaskWhenThereAreProductsLeftToCount',
  unableToCountTaskProductsWhenTaskHasNotBeenStarted: 'unableToCountTaskProductsWhenTaskHasNotBeenStarted',
  unableToCreateAllEnties: 'unableToCreateAllEnties',
  unableToCreateCompanyForDemo: 'unableToCreateCompanyForDemo',
  unableToCreateConfiguration: 'unableToCreateConfiguration',
  unableToCreateEntitiesForMultipleCompanies: 'unableToCreateEntitiesForMultipleCompanies',
  unableToCreateIntegrationSettings: 'unableToCreateIntegrationSettings',
  unableToCreateLotForDisabledLotFeatureToggle: 'unableToCreateLotForDisabledLotFeatureToggle',
  unableToCreateLotForNonLotManagedProductReferenceData: 'unableToCreateLotForNonLotManagedProductReferenceData',
  unableToCreateTaskWithoutAssignedUsers: 'unableToCreateTaskWithoutAssignedUsers',
  unableToCreateTaskWithoutDefiningProductReferenceDataBinsLotsOrContainers:
    'unableToCreateTaskWithoutDefiningProductReferenceDataBinsLotsOrContainers',
  unableToCreateTaskWithoutUsersAssignedForRecount: 'unableToCreateTaskWithoutUsersAssignedForRecount',
  unableToDeleteAllEntities: 'unableToDeleteAllEntities',
  unableToExtractCustomerInformationFromPreviousJobs: 'unableToExtractCustomerInformationFromPreviousJobs',
  unableToFindAvailableBinStatus: 'unableToFindAvailableBinStatus',
  unableToFindBin: 'unableToFindBin',
  unableToFindCodeForUser: 'unableToFindCodeForUser',
  unableToFindCostCenter: 'unableToFindCostCenter',
  unableToFindDefaultBin: 'unableToFindDefaultBin',
  unableToFindDefaultStockLocation: 'unableToFindDefaultStockLocation',
  unableToFindDefaultStockLocationPurchaseOrder: 'unableToFindDefaultStockLocationPurchaseOrder',
  unableToFindDueDateCustomField: 'unableToFindDueDateCustomField',
  unableToFindExternalOrderId: 'unableToFindExternalOrderId',
  unableToFindJobForStockLocationIdentifier: 'unableToFindJobForStockLocationIdentifier',
  unableToFindJobForTransaction: 'unableToFindJobForTransaction',
  unableToFindJournalStockLocation: 'unableToFindJournalStockLocation',
  unableToFindJournalStockLocationXYZ: 'unableToFindJournalStockLocationXYZ',
  unableToFindOrderForLineId: 'unableToFindOrderForLineId',
  unableToFindPlant: 'unableToFindPlant',
  unableToFindProductMasterDataForLine: 'unableToFindProductMasterDataForLine',
  unableToFindTaskForCounting: 'unableToFindTaskForCounting',
  unableToFindTaskSettings: 'unableToFindTaskSettings',
  unableToFindTaskWithId: 'unableToFindTaskWithId',
  unableToFindUploadConfigWithId: 'unableToFindUploadConfigWithId',
  unableToFindUser: 'unableToFindUser',
  unableToFindUserWithEmail: 'unableToFindUserWithEmail',
  unableToGetAccessTokenFromBusinessCentral: 'unableToGetAccessTokenFromBusinessCentral',
  unableToGetEnvironmentFromSettings: 'unableToGetEnvironmentFromSettings',
  unableToGetTenantIdAndOrEnvironmentFromSettings: 'unableToGetTenantIdAndOrEnvironmentFromSettings',
  unableToGetTenantIdOrEnvironmentFromSettings: 'unableToGetTenantIdOrEnvironmentFromSettings',
  unableToParseDateForLotExpiry: 'unableToParseDateForLotExpiry',
  unableToParseHeaders: 'unableToParseHeaders',
  unableToRemoveBinStatusWhenBinsForItExist: 'unableToRemoveBinStatusWhenBinsForItExist',
  unableToRemoveLastAdministratorFromCompany: 'unableToRemoveLastAdministratorFromCompany',
  unableToUpdateEmail: 'unableToUpdateEmail',
  unableToRemoveLotWhenProductsExistForThatLot: 'unableToRemoveLotWhenProductsExistForThatLot',
  unableToRemoveProductReferenceDataWhenProductsExist: 'unableToRemoveProductReferenceDataWhenProductsExist',
  unableToStartTaskThatIsAlreadyCompleted: 'unableToStartTaskThatIsAlreadyCompleted',
  unableToStartTaskThatIsAlreadyInProgress: 'unableToStartTaskThatIsAlreadyInProgress',
  unableToStartTaskThatIsAlreadyProcessed: 'unableToStartTaskThatIsAlreadyProcessed',
  unableToUpdateAllEntities: 'unableToUpdateAllEntities',
  unableToUpdateEntitiesForMultipleCompanies: 'unableToUpdateEntitiesForMultipleCompanies',
  unableToUpdateStockFeatureToggleDisabled: 'unableToUpdateStockFeatureToggleDisabled',
  unableToUpdateStockWhenTaskIsNotComplete: 'unableToUpdateStockWhenTaskIsNotComplete',
  unableToUpdateTaskWithoutAssignedUsers: 'unableToUpdateTaskWithoutAssignedUsers',
  unableToUploadCsvWithoutConfig: 'unableToUploadCsvWithoutConfig',
  unableToUseSelectedConfigurationForImportFile: 'unableToUseSelectedConfigurationForImportFile',
  uneceMeatCarcassesAndCutsClassification: 'uneceMeatCarcassesAndCutsClassification',
  unit: 'unit',
  unitOfMeasure: 'unitOfMeasure',
  unknown: 'unknown',
  unknownBin: 'unknownBin',
  unknownLot: 'unknownLot',
  unknownProduct: 'unknownProduct',
  unknownProductNumber: 'unknownProductNumber',
  unknownProductReference: 'unknownProductReference',
  unknownStockLocation: 'unknownStockLocation',
  unknownUser: 'unknownUser',
  unknownOrder: 'unknownOrder',
  unknownField: 'unknownField',
  update: 'update',
  updateBarcodeConfiguration: 'updateBarcodeConfiguration',
  updateBin: 'updateBin',
  updateBinStatus: 'updateBinStatus',
  updateCustomField: 'updateCustomField',
  updatedAt: 'updatedAt',
  updatedBy: 'updatedBy',
  updateProfile: 'updateProfile',
  updateScanRule: 'updateScanRule',
  updateShippingLocation: 'updateShippingLocation',
  updateStock: 'updateStock',
  updateStockLocationRole: 'updateStockLocationRole',
  updateSuperUser: 'updateSuperUser',
  updateUserDetails: 'updateUserDetails',
  updatingYourProfileWillSignYouOut: 'updatingYourProfileWillSignYouOut',
  uploadConfigurationNotDefined: 'uploadConfigurationNotDefined',
  uploadConfigurationNotFound: 'uploadConfigurationNotFound',
  uploadConfigurationWithNameAlreadyExists: 'uploadConfigurationWithNameAlreadyExists',
  uploadedAt: 'uploadedAt',
  uploadedBy: 'uploadedBy',
  uploadFileHasDuplicateHeaderName: 'uploadFileHasDuplicateHeaderName',
  uploadFileHasMissingRequiredFields: 'uploadFileHasMissingRequiredFields',
  uploadProductImagesInTheFilesAndAssetsSection: 'uploadProductImagesInTheFilesAndAssetsSection',
  urlInput: 'urlInput',
  user: 'user',
  userAlreadyHasRoleForStockLocation: 'userAlreadyHasRoleForStockLocation',
  userAlreadyPartOfCompany: 'userAlreadyPartOfCompany',
  userAssignedToBothInitialCountAndRecount: 'userAssignedToBothInitialCountAndRecount',
  userDetailWithUserIdAlreadyExists: 'userDetailWithUserIdAlreadyExists',
  userDoesNotHaveAnyAssignedStockLocations: 'userDoesNotHaveAnyAssignedStockLocations',
  userInviteEmail: 'userInviteEmail',
  userNotFound: 'userNotFound',
  userWithEmailAlreadyExists: 'userWithEmailAlreadyExists',
  validateBarcodes: 'validateBarcodes',
  validateQuantity: 'validateQuantity',
  valueForCustomFieldXNotValidBooleanGotY: 'valueForCustomFieldXNotValidBooleanGotY',
  valueForCustomFieldXNotValidDateGotY: 'valueForCustomFieldXNotValidDateGotY',
  valueForCustomFieldXNotValidListValueGotYValidZ: 'valueForCustomFieldXNotValidListValueGotYValidZ',
  valueName: 'valueName',
  variableCountOfItems: 'variableCountOfItems',
  verifyDeleteCompany: 'verifyDeleteCompany',
  verifyDeleteFiles: 'verifyDeleteFiles',
  verifyDeleteImportConfiguration: 'verifyDeleteImportConfiguration',
  verifyDeleteOrders: 'verifyDeleteOrders',
  verifyDeleteProductMasterData: 'verifyDeleteProductMasterData',
  verifyDeleteProductMasterDataExportConfiguration: 'verifyDeleteProductMasterDataExportConfiguration',
  verifyDeleteStockLocation: 'verifyDeleteStockLocation',
  verifyDeleteTasks: 'verifyDeleteTasks',
  verifyDeleteTriggers: 'verifyDeleteTriggers',
  verifyDeleteLots: 'verifyDeleteLots',
  verifyEmail: 'verifyEmail',
  viewer: 'viewer',
  vnt: 'vnt',
  volume: 'volume',
  width: 'width',
  wrongClientIdentifier: 'wrongClientIdentifier',
  yes: 'yes',
  yesterday: 'yesterday',
  device: 'device',
  singular: 'singular',
  plural: 'plural',
  uppercase: 'uppercase',
  lowercase: 'lowercase',
  lot: 'lot',
  manageType: 'manageType',
  fileTypeCategory: 'fileTypeCategory',
  fileType: 'fileType',
  file: 'file',
  updateStockRole: 'updateStockRole',
  stockLocationRole: 'stockLocationRole',
  changeCompany: 'changeCompany',
  drop: 'drop',
  click: 'click',
  dragAndDrop: 'dragAndDrop',
  initialCounter: 'initialCounter',
  recounter: 'recounter',
  shipped: 'shipped',
  arrived: 'arrived',
  failed: 'failed',
  disabled: 'disabled',
  enabled: 'enabled',
  verifyDeleteTaskExportConfiguration: 'verifyDeleteTaskExportConfiguration',
  noStockCycleCount: 'noStockCycleCount',
  defaultConfiguration: 'defaultConfiguration',
  leave: 'leave',
  firstAndLastName: 'firstAndLastName',
  stockAdjustment: 'stockAdjustment',
  originalQuantity: 'originalQuantity',
  newQuantity: 'newQuantity',
  move: 'move',
  regexInput: 'regexInput',
  pleaseEnterCompanyNameToConfirm: 'pleaseEnterCompanyNameToConfirm',
  verifyLeaveCompany: 'verifyLeaveCompany',
  verifyRemoveUserFromCompany: 'verifyRemoveUserFromCompany',
  addAdditionalProductMasterDataExportField: 'addAdditionalProductMasterDataExportField',
  orderTransaction: 'orderTransaction',
  triggerStockLocationText: 'triggerStockLocationText',
  filterStockLocationBins: 'filterStockLocationBins',
  addProducts: 'addProducts',
  ignoreValidation: 'ignoreValidation',
  scanRuleField: 'scanRuleField',
  scanRuleStringValue: 'scanRuleStringValue',
  enterStockLocationName: 'enterStockLocationName',
  somethingUnexpectedHappened: 'somethingUnexpectedHappened',
  meter: 'meter',
  gram: 'gram',
  liter: 'liter',
  hide: 'hide',
  show: 'show',
  reorderUserRule: 'reorderUserRule',
  licenseAgreement: 'licenseAgreement',
  privacyPolicy: 'privacyPolicy',
  termsOfUse: 'termsOfUse',
  veryifyDeleteReorderRules: 'veryifyDeleteReorderRules',
  appliesToAllLocations: 'appliesToAllLocations',
  ruleStockLocationText: 'ruleStockLocationText',
  noRulesOrUsersSelected: 'noRulesOrUsersSelected',
  unknownBinStatus: 'unknownBinStatus',
  ruleProductText: 'ruleProductText',
  enterNameOfReorderUserRule: 'enterNameOfReorderUserRule',
  loadAll: 'loadAll',
  veryifyDeleteReorderUserRules: 'veryifyDeleteReorderUserRules',
  reorderQuantity: 'reorderQuantity',
  replenishQuantity: 'replenishQuantity',
  select: 'select',
  directOutbound: 'directOutbound',
  expectedReceiptDate: 'expectedReceiptDate',
  expectedDeliveryDate: 'expectedDeliveryDate',

  createMoveOrder: 'createMoveOrder',

  showToast: 'showToast',
  openSlideUpPanel: 'openSlideUpPanel',
  required: 'required',
  unknownCompany: 'unknownCompany',
  more: 'more',
  home: 'home',
  ongoing: 'ongoing',
  january: 'january',
  february: 'february',
  march: 'march',
  april: 'april',
  may: 'may',
  june: 'june',
  july: 'july',
  august: 'august',
  september: 'september',
  october: 'october',
  november: 'november',
  december: 'december',
  selectTaskType: 'selectTaskType',
  selectTaskStatus: 'selectTaskStatus',
  selectUser: 'selectUser',
  selectManageType: 'selectManageType',
  selectLot: 'selectLot',
  selectProductReference: 'selectProductReference',
  scanner: 'scanner',
  accountSettings: 'accountSettings',
  themeSettings: 'themeSettings',
  deleteAccount: 'deleteAccount',
  selectLanguage: 'selectLanguage',
  enGB: 'enGB',
  enUS: 'enUS',
  ltLT: 'ltLT',
  itIT: 'itIT',
  jaJP: 'jaJP',
  unknownTranslation: 'unknownTranslation',
  details: 'details',
  item: 'item',
  beacon: 'beacon',
  moveOrder: 'moveOrder',
  replenishOrder: 'replenishOrder',
  unknownContact: 'unknownContact',
  draft: 'draft',
  archived: 'archived',
  selectStatus: 'selectStatus',
  selectType: 'selectType',
  task: 'task',
  quickAction: 'quickAction',
  transaction: 'transaction',
  container: 'container',
  upload: 'upload',
  orderNotFound: 'orderNotFound',
  selectProduct: 'selectProduct',
  serverUnavailable: 'serverUnavailable',
  noInternetConnection: 'noInternetConnection',
  notification: 'notification',
  quantityManaged: 'quantityManaged',
  showingXOfYItems: 'showingXOfYItems',
  contactLocation: 'contactLocation',
  productNotFound: 'productNotFound',
  close: 'close',
  selectDate: 'selectDate',
  noProduct: 'noProduct',
  noUser: 'noUser',
  addUser: 'addUser',
  addOrderProduct: 'addOrderProduct',
  successfullyAddedOrderToProduct: 'successfullyAddedOrderToProduct',
  successfullyUpdatedOrderProduct: 'successfullyUpdatedOrderProduct',
  start: 'start',
  startOrderWithoutProductsTitle: 'startOrderWithoutProductsTitle',
  startOrderWithoutProductsPlaceholder: 'startOrderWithoutProductsPlaceholder',
  number: 'number',
  lastUpdated: 'lastUpdated',
  assignedTo: 'assignedTo',
  taskNotFound: 'taskNotFound',
  selectBin: 'selectBin',
  createNewLot: 'createNewLot',
  createNewReferenceData: 'createNewReferenceData',
  date: 'date',
  unknownLpn: 'unknownLpn',
  youHaveUnsavedChanges: 'youHaveUnsavedChanges',
  youHaveUnsavedChangesConfirmationText: 'youHaveUnsavedChangesConfirmationText',
  selectATimeframe: 'selectATimeframe',
  timeframe: 'timeframe',
  trueText: 'trueText',
  falseText: 'falseText',
  loadingStockLocation: 'loadingStockLocation',
  loadingReferenceData: 'loadingReferenceData',
  loadingBinStatusData: 'loadingBinStatusData',
  loadingBin: 'loadingBin',
  loadingTask: 'loadingTask',
  loadingFile: 'loadingFile',
  loadingItem: 'loadingItem',
  findProduct: 'findProduct',
  incorrectBin: 'incorrectBin',
  anomaly: 'anomaly',
  additionalProduct: 'additionalProduct',
  itemWasExpectedInBinXWouldYouLikeToAddIt: 'itemWasExpectedInBinXWouldYouLikeToAddIt',
  scannedItemHasAnomalyWouldYouLikeToAddIt: 'scannedItemHasAnomalyWouldYouLikeToAddIt',
  youHaveScannedAnItemThatWasNotExpectedInThisBinWouldYouLikeToAddIt:
    'youHaveScannedAnItemThatWasNotExpectedInThisBinWouldYouLikeToAddIt',
  pleaseEnterTheCountedQuantity: 'pleaseEnterTheCountedQuantity',
  continueText: 'continueText',
  addTransaction: 'addTransaction',
  fail: 'fail',
  additional: 'additional',
  counted: 'counted',
  missing: 'missing',
  uncounted: 'uncounted',
  inText: 'inText',
  out: 'out',
  resetPassword: 'resetPassword',
  clear: 'clear',
  cameraNotFound: 'cameraNotFound',
  existingBin: 'existingBin',
  newBin: 'newBin',
  whatWouldYouLikeToMapItToQuestion: 'whatWouldYouLikeToMapItToQuestion',
  existingLot: 'existingLot',
  newLot: 'newLot',
  existingProductReferenceData: 'existingProductReferenceData',
  newProductReferenceData: 'newProductReferenceData',
  productReferenceNotFound: 'productReferenceNotFound',
  binNotFound: 'binNotFound',
  noItemsToSelectFrom: 'noItemsToSelectFrom',
  areYouSureYouWantToDeleteYourAccountThisWillPermenantlyDeleteAllDataAndRemovesYouFromAllCompanies:
    'areYouSureYouWantToDeleteYourAccountThisWillPermenantlyDeleteAllDataAndRemovesYouFromAllCompanies',
  pleaseFillInYourDetails: 'pleaseFillInYourDetails',
  provideTheSignInCodeYouHaveReceived: 'provideTheSignInCodeYouHaveReceived',
  signInWithCode: 'signInWithCode',
  myInvitations: 'myInvitations',
  pleaseReviewYourInvitations: 'pleaseReviewYourInvitations',
  myCompany: 'myCompany',
  pleaseSelectYourCompany: 'pleaseSelectYourCompany',
  youAreNotPartOfAnyCompaniesYet: 'youAreNotPartOfAnyCompaniesYet',
  notPartOfACompanySubtext: 'notPartOfACompanySubtext',
  welcomeBack: 'welcomeBack',
  assignedUser: 'assignedUser',
  somethingWentWrong: 'somethingWentWrong',
  somethingWentWrongDuringTheSignInProcessPleaseTryAgain: 'somethingWentWrongDuringTheSignInProcessPleaseTryAgain',
  signedUpSucessfully: 'signedUpSucessfully',
  youWillReceiveAnEmailToVerifyYourAccountShortly: 'youWillReceiveAnEmailToVerifyYourAccountShortly',
  passwordResetSuccessfully: 'passwordResetSuccessfully',
  youWillReceiveAnEmailWithYourResetPasswordShortly: 'youWillReceiveAnEmailWithYourResetPasswordShortly',
  anErrorHasOccurred: 'anErrorHasOccurred',
  added: 'added',
  youHaveSuccessfullyAddedValue: 'youHaveSuccessfullyAddedValue',
  unknownLotNumberScannedWouldYouLikeToAddIt: 'unknownLotNumberScannedWouldYouLikeToAddIt',
  alreadyScanned: 'alreadyScanned',
  thisItemHasAlreadyBeenScanned: 'thisItemHasAlreadyBeenScanned',
  unknownProductNumberScannedWouldYouLikeToAddIt: 'unknownProductNumberScannedWouldYouLikeToAddIt',
  binValueIsNotPartOfThisTask: 'binValueIsNotPartOfThisTask',
  incorrectIdentifier: 'incorrectIdentifier',
  unableToScanIdentifierValueForItemThatIsNotManagedValue: 'unableToScanIdentifierValueForItemThatIsNotManagedValue',
  lockedProductNumber: 'lockedProductNumber',
  unableToSwitchProductNumberAsProductNumberIsCurrentlyLockedForScanning:
    'unableToSwitchProductNumberAsProductNumberIsCurrentlyLockedForScanning',
  incorrectProduct: 'incorrectProduct',
  theScannedProductDoesNotExist: 'theScannedProductDoesNotExist',
  lockedBin: 'lockedBin',
  unableToSwitchBinAsBinIsCurrentlyLockedForScanning: 'unableToSwitchBinAsBinIsCurrentlyLockedForScanning',
  missingBin: 'missingBin',
  pleaseScanBinYouWantToPlaceThisItemIn: 'pleaseScanBinYouWantToPlaceThisItemIn',
  pleaseScanTheAdditionalIdentifierOrUseTheManualInputToLinkIt:
    'pleaseScanTheAdditionalIdentifierOrUseTheManualInputToLinkIt',
  goodJob: 'goodJob',
  itemsLeftToCountValue: 'itemsLeftToCountValue',
  unknownItem: 'unknownItem',
  unableToIdentifyProductReferenceData: 'unableToIdentifyProductReferenceData',
  languageUpdatedSuccessfully: 'languageUpdatedSuccessfully',
  toMakeSureAllChangesTakeEffectItIsRecommendedToSignOutAndSignInAgain:
    'toMakeSureAllChangesTakeEffectItIsRecommendedToSignOutAndSignInAgain',
  clickHereToSignOut: 'clickHereToSignOut',
  passwordChangedSuccessfully: 'passwordChangedSuccessfully',
  pleaseScanTheIdentifierValueForThisProduct: 'pleaseScanTheIdentifierValueForThisProduct',
  showing: 'showing',
  newText: 'newText',
  accentColor: 'accentColor',
  defaultText: 'defaultText',
  untranslatedOnly: 'untranslatedOnly',
  filter: 'filter',

  accountNotVerifiedError: 'accountNotVerifiedError',
  invalidCredentialsError: 'invalidCredentialsError',
  invalidPasswordFormatError: 'invalidPasswordFormatError',
  userAlreadyExistsError: 'userAlreadyExistsError',
  and: 'and',
  businessCentralPurchaseOrderAllHasBeenReceived: 'businessCentralPurchaseOrderAllHasBeenReceived',
  businessCentralPurchaseOrderExceedingExpectedQuantity: 'businessCentralPurchaseOrderExceedingExpectedQuantity',
  comingSoon: 'comingSoon',
  takePicture: 'takePicture',
  processQuickActionSubtitle: 'processQuickActionSubtitle',
  finishTask: 'finishTask',
  finishTaskNotEverythingWasCountedSubtitle: 'finishTaskNotEverythingWasCountedSubtitle',
  rollbackTransaction: 'rollbackTransaction',
  rollbackTransactionSubtitle: 'rollbackTransactionSubtitle',
  cancelTransactionSubtitle: 'cancelTransactionSubtitle',
  completeOrderNotEverythingWasProcessedSubtitle: 'completeOrderNotEverythingWasProcessedSubtitle',
  cancelOrderSubtitle: 'cancelOrderSubtitle',
  seeAll: 'seeAll',
  processTransactionSuccessfulToastTitle: 'processTransactionSuccessfulToastTitle',
  processTransactionSuccessfulToastContent: 'processTransactionSuccessfulToastContent',
  orderFinishedToastTitle: 'orderFinishedToastTitle',
  orderFinishedToastContent: 'orderFinishedToastContent',
  orderCancelToastContent: 'orderCancelToastContent',
  orderCreatedToastContent: 'orderCreatedToastContent',

  syncMaterialMaster: 'syncMaterialMaster',
  pc: 'pc',
  car: 'car',
  pal: 'pal',
  syncStorageLocation: 'syncStorageLocation',
  picking: 'picking',
  issueGoods: 'issueGoods',
  pickingComplete: 'pickingComplete',

  orderCreatedAlertTitle: 'orderCreatedAlertTitle',
  orderCreatedAlertBody: 'orderCreatedAlertBody',

  orderCompletedAlertTitle: 'orderCompletedAlertTitle',
  orderCompletedAlertBody: 'orderCompletedAlertBody',

  productInboundAlertTitle: 'productInboundAlertTitle',
  productInboundAlertBody: 'productInboundAlertBody',

  productOutboundAlertTitle: 'productOutboundAlertTitle',
  productOutboundAlertBody: 'productOutboundAlertBody',

  productMoveAlertTitle: 'productMoveAlertTitle',
  productMoveAlertBody: 'productMoveAlertBody',

  productMoveInboundAlertTitle: 'productMoveInboundAlertTitle',
  productMoveInboundAlertBody: 'productMoveInboundAlertBody',

  productMoveOutboundAlertTitle: 'productMoveOutboundAlertTitle',
  productMoveOutboundAlertBody: 'productMoveOutboundAlertBody',

  customFieldAlertTitle: 'customFieldAlertTitle',
  customFieldAlertBody: 'customFieldAlertBody',

  disable: 'disable',
  tag: 'tag',
  filterTag: 'filterTag',
  createTag: 'createTag',
  updateTag: 'updateTag',
  addTag: 'addTag',
  selectTag: 'selectTag',
  vacant: 'vacant',
  tagRelationAlreadyExists: 'tagRelationAlreadyExists',
  primaryContact: 'primaryContact',
  unknownTag: 'unknownTag',
  updateApplication: 'updateApplication',
  updateApplicationText: 'updateApplicationText',

  validation: 'validation',
  productNotPartOfOrder: 'productNotPartOfOrder',
  productNotPartOfOrderToastText: 'productNotPartOfOrderToastText',
  allTransactionsProcessed: 'allTransactionsProcessed',
  allTransactionsProcessedToastText: 'allTransactionsProcessedToastText',

  allowUncounted: 'allowUncounted',

  picked: 'picked',
  pick: 'pick',
  pickedBy: 'pickedBy',
  pickedAt: 'pickedAt',
  unknownSerial: 'unknownSerial',

  containerType: 'containerType',
  createContainerType: 'createContainerType',
  updateContainerType: 'updateContainerType',
  createContainer: 'createContainer',
  updateContainer: 'updateContainer',
  configuration: 'configuration',
  selectContainer: 'selectContainer',
  selectContainerType: 'selectContainerType',
  identifier: 'identifier',
  deleteOnOutbound: 'deleteOnOutbound',
  deleteOnOutboundContainerTooltip: 'deleteOnOutboundContainerTooltip',
  unknownContainer: 'unknownContainer',
  destinationContainer: 'destinationContainer',
  sourceContainer: 'sourceContainer',
  filterContainer: 'filterContainer',
  filterLot: 'filterLot',
  unknownContainerType: 'unknownContainerType',
  filterContainerType: 'filterContainerType',
  selectProductOrContainer: 'selectProductOrContainer',
  parentContainer: 'parentContainer',
  entityChildType: 'entityChildType',
  parent: 'parent',

  containerIdentifierAlreadyExists: 'containerIdentifierAlreadyExists',

  containerTypeNameAlreadyExists: 'containerTypeNameAlreadyExists',

  loadingContainer: 'loadingContainer',
  loadingContainerType: 'loadingContainerType',

  lockedContainer: 'lockedContainer',
  unableToSwitchContainerAsContainerIsCurrentlyLockedForScanning:
    'unableToSwitchContainerAsContainerIsCurrentlyLockedForScanning',

  createNewContainer: 'createNewContainer',
  youHaveSuccessfullyAddedContainerX: 'youHaveSuccessfullyAddedContainerX',
  createNewBin: 'createNewBin',
  youHaveSuccessfullyAddedBinX: 'youHaveSuccessfullyAddedBinX',
  youHaveSuccessfullyAddedLotX: 'youHaveSuccessfullyAddedLotX',
  enterAValue: 'enterAValue',
  selectAValue: 'selectAValue',
  existingContainer: 'existingContainer',
  newContainer: 'newContainer',
  manualSelection: 'manualSelection',
  none: 'none',
  containerNotFound: 'containerNotFound',
  incorrectStockLocation: 'incorrectStockLocation',
  theScannedItemDoesNotBelongToThisStockLocation: 'theScannedItemDoesNotBelongToThisStockLocation',

  unknownSerialToastText: 'unknownSerialToastText',

  unknownLPN: 'unknownLPN',
  unknownLPNToastText: 'unknownLPNToastText',

  unknownBinToastText: 'unknownBinToastText',

  unknownLotToastText: 'unknownLotToastText',

  unknownProductMasterData: 'unknownProductMasterData',
  unknownProductMasterDataToastText: 'unknownProductMasterDataToastText',

  unknownStockLocationToastText: 'unknownStockLocationToastText',

  serialAlreadyExists: 'serialAlreadyExists',
  serialAlreadyExistsToastText: 'serialAlreadyExistsToastText',

  lpnAlreadyExists: 'lpnAlreadyExists',
  lpnAlreadyExistsToastText: 'lpnAlreadyExistsToastText',

  changeLockedProductNumber: 'changeLockedProductNumber',
  changeLockedProductNumberToastText: 'changeLockedProductNumberToastText',

  changeLockedBin: 'changeLockedBin',
  changeLockedBinToastText: 'changeLockedBinToastText',

  changeLockedLot: 'changeLockedLot',
  changeLockedLotToastTest: 'changeLockedLotToastTest',

  changeLockedContainer: 'changeLockedContainer',
  changeLockedContainerToastText: 'changeLockedContainerToastText',

  lotMismatch: 'lotMismatch',
  lotMismatchToastText: 'lotMismatchToastText',

  serialMismatch: 'serialMismatch',
  serialMismatchToastText: 'serialMismatchToastText',

  lpnMismatch: 'lpnMismatch',
  lpnMismatchToastText: 'lpnMismatchToastText',

  incorrectSerialStockLocation: 'incorrectSerialStockLocation',
  incorrectSerialStockLocationToastText: 'incorrectSerialStockLocationToastText',

  incorrectLPNStockLocation: 'incorrectLPNStockLocation',
  incorrectLPNStockLocationToastText: 'incorrectLPNStockLocationToastText',

  incorrectBinStockLocation: 'incorrectBinStockLocation',
  incorrectBinStockLocationToastText: 'incorrectBinStockLocationToastText',

  binInboundNotAllowed: 'binInboundNotAllowed',
  binInboundNotAllowedToastText: 'binInboundNotAllowedToastText',

  binOutboundNotAllowed: 'binOutboundNotAllowed',
  binOutboundNotAllowedToastText: 'binOutboundNotAllowedToastText',

  pickTransactionSuccessful: 'pickTransactionSuccessful',
  pickTransactionSuccessfulToastText: 'pickTransactionSuccessfulToastText',

  incorrectContainerStockLocation: 'incorrectContainerStockLocation',
  incorrectContainerStockLocationToastText: 'incorrectContainerStockLocationToastText',
  incorrectContainerBin: 'incorrectContainerBin',
  incorrectContainerBinToastText: 'incorrectContainerBinToastText',
  processChildrenQuestion: 'processChildrenQuestion',

  scanRequired: 'scanRequired',
  scanRequiredWarning: 'scanRequiredWarning',
  scanRequiredContainerPlaceholder: 'scanRequiredContainerPlaceholder',
  scanRequiredWarningScanProductNumber: 'scanRequiredWarningScanProductNumber',

  productBasedApproach: 'productBasedApproach',
  productBasedApproachFeatureToggleTooltip: 'productBasedApproachFeatureToggleTooltip',

  containersFeatureToggleTooltip: 'containersFeatureToggleTooltip',

  unknownCustomField: 'unknownCustomField',
  unknownProductIdentifier: 'unknownProductIdentifier',
  unknownProductIdentifierToastText: 'unknownProductIdentifierToastText',
  lotUniqueCompany: 'lotUniqueCompany',
  lotUniqueProductMasterData: 'lotUniqueProductMasterData',

  lotWithNumberAlreadyExists: 'lotWithNumberAlreadyExists',

  signUpEmailMessage: 'signUpEmailMessage',
  assetSerialChangeNotAllowed: 'assetSerialChangeNotAllowed',
  assetProductMasterDataChangeNotAllowed: 'assetProductMasterDataChangeNotAllowed',
  assetConfirmReceive: 'assetConfirmReceive',
  assetApproveReceivalMessage: 'assetApproveReceivalMessage',
  assetConfirmReturn: 'assetConfirmReturn',
  assetConfirmReturnMessage: 'assetConfirmReturnMessage',
  assetDeleteNotAllowedForUserMessage: 'assetDeleteNotAllowedForUserMessage',

  assetTransactionSerialRequired: 'assetTransactionSerialRequired',
  assetTransactionSerialQuantity: 'assetTransactionSerialQuantity',
  assetTransactionSerialMismatch: 'assetTransactionSerialMismatch',

  assetTransactionSerialChangeNotAllowed: 'assetTransactionSerialChangeNotAllowed',
  assetTransactionProductMasterDataChangeNotAllowed: 'assetTransactionProductMasterDataChangeNotAllowed',
  assetTransactionTypeChangeNotAllowed: 'assetTransactionTypeChangeNotAllowed',

  assetManagement: 'assetManagement',
  asset: 'asset',
  searchForAsset: 'searchForAsset',
  removeFromAssets: 'removeFromAssets',
  availableQuantity: 'availableQuantity',
  createNewAsset: 'createNewAsset',
  assignAsset: 'assignAsset',
  returnAsset: 'returnAsset',
  issueReturn: 'issueReturn',
  myAssets: 'myAssets',
  sign: 'sign',
  reassign: 'reassign',
  reassignAsset: 'reassignAsset',

  issued: 'issued',
  available: 'available',
  selected: 'selected',
  quantityToAssign: 'quantityToAssign',
  pending: 'pending',
  signedAt: 'signedAt',
  signReturn: 'signReturn',
  signAssign: 'signAssign',

  completedReturn: 'completedReturn',
  completedAssign: 'completedAssign',
  pendingReturn: 'pendingReturn',
  pendingAssign: 'pendingAssign',
  returnToUser: 'returnToUser',

  assetName: 'assetName',
  assetNumber: 'assetNumber',
  assetStatus: 'assetStatus',
  assetComplete: 'assetComplete',

  showingXOfYAssets: 'showingXOfYAssets',
  generated: 'generated',

  updateQuantity: 'updateQuantity',
  updateQuantityInfo: 'updateQuantityInfo',
  count: 'count',
  countTaskProduct: 'countTaskProduct',
  countTaskProductInfo: 'countTaskProductInfo',
  updateTaskProductQuantityInfo: 'updateTaskProductQuantityInfo',
  additionalTaskProductInfo: 'additionalTaskProductInfo',
  successfulProductCountInfo: 'successfulProductCountInfo',

  importAssets: 'importAssets',
  importLots: 'importLots',

  orderUpdatedSuccessfullyToastTitle: 'orderUpdatedSuccessfullyToastTitle',

  handlingUnit: 'handlingUnit',
  handlingUnitScreenSubtitle: 'handlingUnitScreenSubtitle',
  handlingUnitBreak: 'handlingUnitBreak',
  handlingUnitBundle: 'handlingUnitBundle',
  handlingUnitCreate: 'handlingUnitCreate',
  handlingUnitUpdate: 'handlingUnitUpdate',
  handlingUnitDelete: 'handlingUnitDelete',
  handlingUnitBreakInto: 'handlingUnitBreakInto',
  handlingUnitBundleInto: 'handlingUnitBundleInto',
  handlingUnitResult: 'handlingUnitResult',
  handlingUnitFilter: 'handlingUnitFilter',

  handlingUnitDeleteModalPrimaryText: 'handlingUnitDeleteModalPrimaryText',

  handlingUnitCreatedSuccessfullyToastTitle: 'handlingUnitCreatedSuccessfullyToastTitle',
  handlingUnitUpdatedSuccessfullyToastTitle: 'handlingUnitUpdatedSuccessfullyToastTitle',
  handlingUnitDeletedSuccessfullyToastTitle: 'handlingUnitDeletedSuccessfullyToastTitle',
  handlingUnitBreakSuccessfullyToastTitle: 'handlingUnitBreakSuccessfullyToastTitle',
  handlingUnitBundleSuccessfullyToastTitle: 'handlingUnitBundleSuccessfullyToastTitle',

  handlingUnitProductMasterDataIdParentIdEqualityError: 'handlingUnitProductMasterDataIdParentIdEqualityError',
  handlingUnitQuantityError: 'handlingUnitQuantityError',
  handlingUnitUnableToChangeProductMasterDataError: 'handlingUnitUnableToChangeProductMasterDataError',
  handlingUnitBreakNegativeQuantityError: 'handlingUnitBreakNegativeQuantityError',
  handlingUnitUnableToFindHandlingUnitError: 'handlingUnitUnableToFindHandlingUnitError',
  handlingUnitUnableToDetermineConnectionError: 'handlingUnitUnableToDetermineConnectionError',
  handlingUnitInsufficientQuantityToBreakError: 'handlingUnitInsufficientQuantityToBreakError',
  handlingUnitInsufficientQuantityToBundleError: 'handlingUnitInsufficientQuantityToBundleError',

  productMasterDataHandlingUnitQuantityError: 'productMasterDataHandlingUnitQuantityError',

  // REDESIGN
  personalInformation: 'personalInformation',
  displaySettings: 'displaySettings',
  scanning: 'scanning',
  securityAndAccess: 'securityAndAccess',
  saveChanges: 'saveChanges',
  deleteCompany: 'deleteCompany',
  search: 'search',
  regex: 'regex',
  createNew: 'createNew',
  unknownCountry: 'unknownCountry',
  containerBasedApproachFeatureToggleTitle: 'containerBasedApproachFeatureToggleTitle',
  containerBasedApproachFeatureToggleExplanation: 'containerBasedApproachFeatureToggleExplanation',
  tagWithNameAlreadyExists: 'tagWithNameAlreadyExists',
  userUpdatedSuccessfullyToastTitle: 'userUpdatedSuccessfullyToastTitle',
  userManagement: 'userManagement',
  removeFromCompany: 'removeFromCompany',
  stockLocationRoleUpdatedSuccessfullyToastTitle: 'stockLocationRoleUpdatedSuccessfullyToastTitle',
  assignToLocation: 'assignToLocation',
  manageYourStockLocations: 'manageYourStockLocations',
  locationDetails: 'locationDetails',
  stockLocationUpdatedSuccessfullyToast: 'stockLocationUpdatedSuccessfullyToast',
  addUserToLocation: 'addUserToLocation',
  stockLocationCreatedSuccessfullyToast: 'stockLocationCreatedSuccessfullyToast',
  createNewStockLocation: 'createNewStockLocation',
  insufficientAddressInformationToAttemptCoordinatesLookupToastTitle:
    'insufficientAddressInformationToAttemptCoordinatesLookupToastTitle',
  unableToFindValidCoordinatesForThisAddressToastTitle: 'unableToFindValidCoordinatesForThisAddressToastTitle',
  stockLocationNameInputPlaceholder: 'stockLocationNameInputPlaceholder',
  stockLocationIdentifierInputPlaceholder: 'stockLocationIdentifierInputPlaceholder',
  addressLine1InputPlaceholder: 'addressLine1InputPlaceholder',
  addressLine2InputPlaceholder: 'addressLine2InputPlaceholder',
  postalCodeInputPlaceholder: 'postalCodeInputPlaceholder',
  countryInputPlaceholder: 'countryInputPlaceholder',
  regionInputPlaceholder: 'regionInputPlaceholder',
  cityInputPlaceholder: 'cityInputPlaceholder',
  companyDetailsTab: 'companyDetailsTab',
  customTranslationsTab: 'customTranslationsTab',
  companyUpdatedSuccessfullyToastTitle: 'companyUpdatedSuccessfullyToastTitle',
  displaySettingsLogoInformation: 'displaySettingsLogoInformation',
  displaySettingsRecommendedLogoResolution: 'displaySettingsRecommendedLogoResolution',
  displaySettingsMaximumLogoFileSize: 'displaySettingsMaximumLogoFileSize',
  displaySettingsPrimaryColorInformation: 'displaySettingsPrimaryColorInformation',
  displaySettingsHeaderColorInformation: 'displaySettingsHeaderColorInformation',
  changeLogo: 'changeLogo',
  displaySettingsNote: 'displaySettingsNote',
  note: 'note',
  branding: 'branding',
  displaySettingsCustomTranslationsTitle: 'displaySettingsCustomTranslationsTitle',
  displaySettingsCustomTranslationsSubtitle: 'displaySettingsCustomTranslationsSubtitle',
  customFieldSettingsScreenTitle: 'customFieldSettingsScreenTitle',
  customFieldSettingsScreenSubtitle: 'customFieldSettingsScreenSubtitle',
  customFieldCreatedSuccessfullyToastTitle: 'customFieldCreatedSuccessfullyToastTitle',
  customFieldUpdatedSuccessfullyToastTitle: 'customFieldUpdatedSuccessfullyToastTitle',
  value: 'value',
  customFieldAddedValueAlreadyExistsToastTitle: 'customFieldAddedValueAlreadyExistsToastTitle',
  integrationSettingsScreenTitle: 'integrationSettingsScreenTitle',
  integrationSettingsScreenSubtitle: 'integrationSettingsScreenSubtitle',
  integrationSettingsBannerTitle: 'integrationSettingsBannerTitle',
  integrationSettingsBannerContent: 'integrationSettingsBannerContent',
  integrationModalUpdateTitle: 'integrationModalUpdateTitle',
  integrationModalCreateTitle: 'integrationModalCreateTitle',
  customTranslationRecordModalTitle: 'customTranslationRecordModalTitle',
  englishSingular: 'englishSingular',
  customSingular: 'customSingular',
  customSingularPlaceholder: 'customSingularPlaceholder',
  englishPlural: 'englishPlural',
  customPlural: 'customPlural',
  customPluralPlaceholder: 'customPluralPlaceholder',
  scanRuleSettingsPaneTitle: 'scanRuleSettingsPaneTitle',
  scanRuleSettingsPaneSubtitle: 'scanRuleSettingsPaneSubtitle',
  scanRule: 'scanRule',
  scanRuleUpdatedSuccessfullyToastTitle: 'scanRuleUpdatedSuccessfullyToastTitle',
  scanRuleCreatedSuccessfullyToastTitle: 'scanRuleCreatedSuccessfullyToastTitle',
  scanRuleModalRegexValueLabel: 'scanRuleModalRegexValueLabel',
  scanRuleModalRegexValuePlaceholder: 'scanRuleModalRegexValuePlaceholder',
  authenticationSettingsUpdatedSuccessfullyToastTitle: 'authenticationSettingsUpdatedSuccessfullyToastTitle',
  authenticationSettingsViewTitle: 'authenticationSettingsViewTitle',
  authenticationSettingsViewSubtitle: 'authenticationSettingsViewSubtitle',
  deleteCompanyModalTitle: 'deleteCompanyModalTitle',
  deleteCompanyModalListItemStockLocation: 'deleteCompanyModalListItemStockLocation',
  deleteCompanyModalListItemProduct: 'deleteCompanyModalListItemProduct',
  deleteCompanyModalListItemTasksAndOrders: 'deleteCompanyModalListItemTasksAndOrders',
  deleteCompanyModalListItemBinsAndLots: 'deleteCompanyModalListItemBinsAndLots',
  deleteCompanyModalListItemHistoricalRecordsAndActivityLog:
    'deleteCompanyModalListItemHistoricalRecordsAndActivityLog',
  deleteCompanyModalListItemUserRolesAndPermissions: 'deleteCompanyModalListItemUserRolesAndPermissions',
  deleteCompanyModalActionCannotBeUndoneWarning: 'deleteCompanyModalActionCannotBeUndoneWarning',
  deleteCompanyModalConfirmationText: 'deleteCompanyModalConfirmationText',
  deleteCompanyModalValidateCompanyNameInputLabel: 'deleteCompanyModalValidateCompanyNameInputLabel',
  deleteCompanyViewTitle: 'deleteCompanyViewTitle',
  deleteCompanyViewSubtitle: 'deleteCompanyViewSubtitle',
  deleteCompanyViewConfirmationText: 'deleteCompanyViewConfirmationText',
  binCreatedSuccessfullyToastTitle: 'binCreatedSuccessfullyToastTitle',
  binUpdatedSuccessfullyToastTitle: 'binUpdatedSuccessfullyToastTitle',
  stockLocationRoleAssignmentCreatedSuccessfully: 'stockLocationRoleAssignmentCreatedSuccessfully',
  assignUserToLocation: 'assignUserToLocation',
  stockLocationSettingsScreenTitle: 'stockLocationSettingsScreenTitle',
  stockLocationSettingsScreenSubtitle: 'stockLocationSettingsScreenSubtitle',
  tagCreatedSuccessfullyToastTitle: 'tagCreatedSuccessfullyToastTitle',
  tagUpdatedSuccessfullyToastTitle: 'tagUpdatedSuccessfullyToastTitle',
  tagSettingsScreenTitle: 'tagSettingsScreenTitle',
  tagSettingsScreenSubtitle: 'tagSettingsScreenSubtitle',
  leftCompanySuccessfullyToastTitle: 'leftCompanySuccessfullyToastTitle',
  removedUserFromCompanySuccessfullyToastTitle: 'removedUserFromCompanySuccessfullyToastTitle',
  remove: 'remove',
  deleteCompanyRoleAssignmentLeaveModalTitle: 'deleteCompanyRoleAssignmentLeaveModalTitle',
  deleteCompanyRoleAssignmentRemoveUserModalTitle: 'deleteCompanyRoleAssignmentRemoveUserModalTitle',
  deleteCompanyRoleAssignmentLeaveModalSubtitle: 'deleteCompanyRoleAssignmentLeaveModalSubtitle',
  deleteCompanyRoleAssignmentRemoveUserModalSubtitle: 'deleteCompanyRoleAssignmentRemoveUserModalSubtitle',
  createStockLocationRoleForUserTitle: 'createStockLocationRoleForUserTitle',
  stockLocationRoleAssignmentRemovedSuccessfullyToastTitle: 'stockLocationRoleAssignmentRemovedSuccessfullyToastTitle',
  deleteStockLocationRolesModalTitle: 'deleteStockLocationRolesModalTitle',
  deleteStockLocationRolesModalSubtitle: 'deleteStockLocationRolesModalSubtitle',
  userSettingsScreenTitle: 'userSettingsScreenTitle',
  totalUsers: 'totalUsers',
  binStatusModalStatusInputPlaceholder: 'binStatusModalStatusInputPlaceholder',
  binStatusCreatedSuccessfullyToastTitle: 'binStatusCreatedSuccessfullyToastTitle',
  binStatusUpdatedSuccessfullyToastTitle: 'binStatusUpdatedSuccessfullyToastTitle',
  containerTypesOverviewPaneTitle: 'containerTypesOverviewPaneTitle',
  containerTypeOverviewPaneSubtitle: 'containerTypeOverviewPaneSubtitle',
  containerTypeUpdatedSuccessfullyToastTitle: 'containerTypeUpdatedSuccessfullyToastTitle',
  containerTypeCreatedSuccessfullyToastTitle: 'containerTypeCreatedSuccessfullyToastTitle',
  containerTypeNameInputPlaceholder: 'containerTypeNameInputPlaceholder',
  binStatusOverviewPaneTitle: 'binStatusOverviewPaneTitle',
  binStatusOverviewPaneSubtitle: 'binStatusOverviewPaneSubtitle',
  key: 'key',
  translationRecord: 'translationRecord',
  importConfigurationScreenSubtitle: 'importConfigurationScreenSubtitle',
  importConfigurationScreenTitle: 'importConfigurationScreenTitle',
  personalInformationSettingsScreenTitle: 'personalInformationSettingsScreenTitle',
  personalInformationSettingsScreenSubtitle: 'personalInformationSettingsScreenSubtitle',
  usersInvitedSuccessfullyToastTitle: 'usersInvitedSuccessfullyToastTitle',
  deleteStockLocationModalTitle: 'deleteStockLocationModalTitle',
  deleteStockLocationModalPrimaryText: 'deleteStockLocationModalPrimaryText',
  deleteStockLocationModalActionCannotBeUndoneWarning: 'deleteStockLocationModalActionCannotBeUndoneWarning',
  deleteStockLocationModalConfirmationText: 'deleteStockLocationModalConfirmationText',
  deleteCompanyModalPrimaryText: 'deleteCompanyModalPrimaryText',
  deleteLocation: 'deleteLocation',
  stockLocationDeleteSuccessfullyToastTitle: 'stockLocationDeleteSuccessfullyToastTitle',
  deleteStockLocationModalValidateStockLocationNameInputLabel:
    'deleteStockLocationModalValidateStockLocationNameInputLabel',
  featureToggleSettingsScreenTitle: 'featureToggleSettingsScreenTitle',
  featureToggleSettingsScreenSubtitle: 'featureToggleSettingsScreenSubtitle',

  orderOrderFeatureToggleTitle: 'orderOrderFeatureToggleTitle',
  orderOrderFeatureToggleExplanation: 'orderOrderFeatureToggleExplanation',
  orderOrderFeatureToggleInformation: 'orderOrderFeatureToggleInformation',
  orderCustomerFeatureToggleTitle: 'orderCustomerFeatureToggleTitle',
  orderCustomerFeatureToggleExplanation: 'orderCustomerFeatureToggleExplanation',
  orderSupplierFeatureToggleTitle: 'orderSupplierFeatureToggleTitle',
  orderSupplierFeatureToggleExplanation: 'orderSupplierFeatureToggleExplanation',
  orderPickingFeatureToggleTitle: 'orderPickingFeatureToggleTitle',
  orderPickingFeatureToggleExplanation: 'orderPickingFeatureToggleExplanation',
  orderSendMailOnAssignedFeatureToggleTitle: 'orderSendMailOnAssignedFeatureToggleTitle',
  orderSendMailOnAssignedFeatureToggleExplanation: 'orderSendMailOnAssignedFeatureToggleExplanation',
  orderEditProductsOnInboundFeatureToggleTitle: 'orderEditProductsOnInboundFeatureToggleTitle',
  orderEditProductsOnInboundFeatureToggleExplanation: 'orderEditProductsOnInboundFeatureToggleExplanation',
  orderEditProductsOnOutboundFeatureToggleTitle: 'orderEditProductsOnOutboundFeatureToggleTitle',
  orderEditProductsOnOutboundFeatureToggleExplanation: 'orderEditProductsOnOutboundFeatureToggleExplanation',
  orderProductSelectionFirstFeatureToggleTitle: 'orderProductSelectionFirstFeatureToggleTitle',
  orderProductSelectionFirstFeatureToggleExplanation: 'orderProductSelectionFirstFeatureToggleExplanation',
  orderIgnoreAvailableQuantityWhenCreatingOrdersFeatureToggleTitle:
    'orderIgnoreAvailableQuantityWhenCreatingOrdersFeatureToggleTitle',
  orderIgnoreAvailableQuantityWhenCreatingOrdersFeatureToggleExplanation:
    'orderIgnoreAvailableQuantityWhenCreatingOrdersFeatureToggleExplanation',
  orderContainerBasedApproachFeatureToggleTitle: 'orderContainerBasedApproachFeatureToggleTitle',
  orderContainerBasedApproachFeatureToggleExplanation: 'orderContainerBasedApproachFeatureToggleExplanation',

  taskTaskFeatureToggleTitle: 'taskTaskFeatureToggleTitle',
  taskTaskFeatureToggleExplanation: 'taskTaskFeatureToggleExplanation',
  taskTaskFeatureToggleInformation: 'taskTaskFeatureToggleInformation',
  taskCycleCountFeatureToggleTitle: 'taskCycleCountFeatureToggleTitle',
  taskCycleCountFeatureToggleExplanation: 'taskCycleCountFeatureToggleExplanation',
  taskBlindCountFeatureToggleTitle: 'taskBlindCountFeatureToggleTitle',
  taskBlindCountFeatureToggleExplanation: 'taskBlindCountFeatureToggleExplanation',
  taskAllowStockUpdateAfterFinishingTaskFeatureToggleTitle: 'taskAllowStockUpdateAfterFinishingTaskFeatureToggleTitle',
  taskAllowStockUpdateAfterFinishingTaskFeatureToggleExplanation:
    'taskAllowStockUpdateAfterFinishingTaskFeatureToggleExplanation',

  assetManagementAssetManagementFeatureToggleTitle: 'assetManagementAssetManagementFeatureToggleTitle',
  assetManagementAssetManagementFeatureToggleExplanation: 'assetManagementAssetManagementFeatureToggleExplanation',
  assetManagementAssetManagementFeatureToggleInformation: 'assetManagementAssetManagementFeatureToggleInformation',
  assetManagementInboundOrderFeatureToggleTitle: 'assetManagementInboundOrderFeatureToggleTitle',
  assetManagementInboundOrderFeatureToggleExplanation: 'assetManagementInboundOrderFeatureToggleExplanation',

  lotLotFeatureToggleTitle: 'lotLotFeatureToggleTitle',
  lotLotFeatureToggleExplanation: 'lotLotFeatureToggleExplanation',
  lotLotFeatureToggleInformation: 'lotLotFeatureToggleInformation',
  lotLotsUniqueWithinCompanyFeatureToggleTitle: 'lotLotsUniqueWithinCompanyFeatureToggleTitle',
  lotLotsUniqueWithinCompanyFeatureToggleExplanation: 'lotLotsUniqueWithinCompanyFeatureToggleExplanation',
  lotLotsUniqueForProductReferenceDataFeatureToggleTitle: 'lotLotsUniqueForProductReferenceDataFeatureToggleTitle',
  lotLotsUniqueForProductReferenceDataFeatureToggleExplanation:
    'lotLotsUniqueForProductReferenceDataFeatureToggleExplanation',

  productTransactionProductTransactionFeatureToggleTitle: 'productTransactionProductTransactionFeatureToggleTitle',
  productTransactionProductTransactionFeatureToggleExplanation:
    'productTransactionProductTransactionFeatureToggleExplanation',
  productTransactionProductTransactionFeatureToggleInformation:
    'productTransactionProductTransactionFeatureToggleInformation',
  productTransactionWebFeatureToggleTitle: 'productTransactionWebFeatureToggleTitle',
  productTransactionWebFeatureToggleExplanation: 'productTransactionWebFeatureToggleExplanation',
  productTransactionScanRequiredFeatureToggleTitle: 'productTransactionScanRequiredFeatureToggleTitle',
  productTransactionScanRequiredFeatureToggleExplanation: 'productTransactionScanRequiredFeatureToggleExplanation',

  containerContainerFeatureToggleTitle: 'containerContainerFeatureToggleTitle',
  containerContainerFeatureToggleExplanation: 'containerContainerFeatureToggleExplanation',
  containerContainerFeatureToggleInformation: 'containerContainerFeatureToggleInformation',

  containerContainerAllowBinMismatchFeatureToggleTitle: 'containerContainerAllowBinMismatchFeatureToggleTitle',
  containerContainerAllowBinMismatchFeatureToggleExplanation:
    'containerContainerAllowBinMismatchFeatureToggleExplanation',

  sessionStorageSessionStorageFeatureToggleTitle: 'sessionStorageSessionStorageFeatureToggleTitle',
  sessionStorageSessionStorageFeatureToggleExplanation: 'sessionStorageSessionStorageFeatureToggleExplanation',
  sessionStorageSessionStorageFeatureToggleInformation: 'sessionStorageSessionStorageFeatureToggleInformation',

  quickActionQuickActionFeatureToggleTitle: 'quickActionQuickActionFeatureToggleTitle',
  quickActionQuickActionFeatureToggleExplanation: 'quickActionQuickActionFeatureToggleExplanation',
  quickActionQuickActionFeatureToggleInformation: 'quickActionQuickActionFeatureToggleInformation',

  alertAlertFeatureToggleTitle: 'alertAlertFeatureToggleTitle',
  alertAlertFeatureToggleExplanation: 'alertAlertFeatureToggleExplanation',
  alertAlertFeatureToggleInformation: 'alertAlertFeatureToggleInformation',

  taskAllowUncountedFeatureToggleTitle: 'taskAllowUncountedFeatureToggleTitle',
  taskAllowUncountedFeatureToggleExplanation: 'taskAllowUncountedFeatureToggleExplanation',
  taskOrderFeatureToggleTitle: 'taskOrderFeatureToggleTitle',
  taskOrderFeatureToggleExplanation: 'taskOrderFeatureToggleExplanation',
  taskOrderInboundFeatureToggleTitle: 'taskOrderInboundFeatureToggleTitle',
  taskOrderInboundFeatureToggleExplanation: 'taskOrderInboundFeatureToggleExplanation',
  taskOrderInboundFeatureToggleInformation: 'taskOrderInboundFeatureToggleInformation',
  taskOrderMoveFeatureToggleTitle: 'taskOrderMoveFeatureToggleTitle',
  taskOrderMoveFeatureToggleExplanation: 'taskOrderMoveFeatureToggleExplanation',
  taskOrderOutboundFeatureToggleTitle: 'taskOrderOutboundFeatureToggleTitle',
  taskOrderOutboundFeatureToggleExplanation: 'taskOrderOutboundFeatureToggleExplanation',
  taskOrderOutboundFeatureToggleInformation: 'taskOrderOutboundFeatureToggleInformation',
  taskOrderRefillFeatureToggleTitle: 'taskOrderRefillFeatureToggleTitle',
  taskOrderRefillFeatureToggleExplanation: 'taskOrderRefillFeatureToggleExplanation',
  taskOrderRefillIgnoreOverstockFeatureToggleTitle: 'taskOrderRefillIgnoreOverstockFeatureToggleTitle',
  taskOrderRefillIgnoreOverstockFeatureToggleExplanation: 'taskOrderRefillIgnoreOverstockFeatureToggleExplanation',
  taskOrderAutoCreateFeatureToggleTitle: 'taskOrderAutoCreateFeatureToggleTitle',
  taskOrderAutoCreateFeatureToggleExplanation: 'taskOrderAutoCreateFeatureToggleExplanation',

  unableToReadFile: 'unableToReadFile',
  invalidContent: 'invalidContent',
  noContent: 'noContent',

  tagNameIsRequiredAndMayNotBeEmptyError: 'tagNameIsRequiredAndMayNotBeEmptyError',
  updatingTagTypeIsNotAllowed: 'updatingTagTypeIsNotAllowed',

  exportReorderRules: 'exportReorderRules',
  splitByRule: 'splitByRule',
  addAdditionalReorderRuleExportField: 'addAdditionalReorderRuleExportField',
  selectEntityTypeForTrigger: 'selectEntityTypeForTrigger',
  cannotDeleteDefaultTriggers: 'cannotDeleteDefaultTriggers',
  lotLotsExpiryManagementFeatureToggleTitle: 'lotLotsExpiryManagementFeatureToggleTitle',
  lotLotsExpiryManagementFeatureToggleExplanation: 'lotLotsExpiryManagementFeatureToggleExplanation',
  expiryTracking: 'expiryTracking',
  expiryTrackingTooltip: 'expiryTrackingTooltip',

  expiry: 'expiry',
  mobileAppBarTasks: 'mobileAppBarTasks',
  selectTaskRecountAssignees: 'selectTaskRecountAssignees',
  noBinsProductsLotsOrContainersFoundForThisStockLocation: 'noBinsProductsLotsOrContainersFoundForThisStockLocation',
  chooseAnotherLocation: 'chooseAnotherLocation',
  noValidUsersFound: 'noValidUsersFound',
  noValidTaskUsersFoundExplanation: 'noValidTaskUsersFoundExplanation',
  productAddedToOrderSuccessfullyToastTitle: 'productAddedToOrderSuccessfullyToastTitle',

  deleteTagModalTitle: 'deleteTagModalTitle',
  tagDeletedSuccessfullyToastTitle: 'tagDeletedSuccessfullyToastTitle',
  deleteTag: 'deleteTag',
  deleteTagModalSubtitle: 'deleteTagModalSubtitle',

  customFieldDeleteSuccessfullyToastTitle: 'customFieldDeleteSuccessfullyToastTitle',
  deleteCustomFieldModalTitle: 'deleteCustomFieldModalTitle',
  deleteCustomFieldModalSubtitle: 'deleteCustomFieldModalSubtitle',
  deleteCustomField: 'deleteCustomField',

  binDeletedSuccessfullyToastTitle: 'binDeletedSuccessfullyToastTitle',
  scanRuleDeleteSuccessfullyToastTitle: 'scanRuleDeleteSuccessfullyToastTitle',
  noBinsBlindCount: 'noBinsBlindCount',

  importReorderRuleProducts: 'importReorderRuleProducts',
  noImportConfigurationsYetTitle: 'noImportConfigurationsYetTitle',
  noImportConfigurationsYetSubtitle: 'noImportConfigurationsYetSubtitle',
  noIntegrationsYetTitle: 'noIntegrationsYetTitle',
  displaySettingsLanguageInformation: 'displaySettingsLanguageInformation',
  csvUploadConfigurationNameAlreadyExists: 'csvUploadConfigurationNameAlreadyExists',
  createCustomerContainer: 'createCustomerContainer',

  onCreate: 'onCreate',
  userAssignedToOrderMustBeAtLeastStockLocationUser: 'userAssignedToOrderMustBeAtLeastStockLocationUser',
  addingProductsToInboundOrdersIsDisabledInYourCompany: 'addingProductsToInboundOrdersIsDisabledInYourCompany',
  addingProductsToOutboundOrdersIsDisabledInYourCompany: 'addingProductsToOutboundOrdersIsDisabledInYourCompany',
  addingProductsToMoveOrdersIsDisabledInYourCompany: 'addingProductsToMoveOrdersIsDisabledInYourCompany',

  orderSettingsPaneTitle: 'orderSettingsPaneTitle',
  orderSettingsPaneSubtitle: 'orderSettingsPaneSubtitle',

  orderSettingsCreatedToastTitle: 'orderSettingsCreatedToastTitle',
  orderSettingsUpdatedToastTitle: 'orderSettingsUpdatedToastTitle',

  orderEditProductsOnMoveFeatureToggleTitle: 'orderEditProductsOnMoveFeatureToggleTitle',
  orderEditProductsOnMoveFeatureToggleExplanation: 'orderEditProductsOnMoveFeatureToggleExplanation',

  lotCreatedSuccessfullyToastTitle: 'lotCreatedSuccessfullyToastTitle',
  lotUpdatedSuccessfullyToastTitle: 'lotUpdatedSuccessfullyToastTitle',

  productMasterDataCreatedSuccessfullyToastTitle: 'productMasterDataCreatedSuccessfullyToastTitle',
  productMasterDataUpdatedSuccessfullyToastTitle: 'productMasterDataUpdatedSuccessfullyToastTitle',

  containerCreatedSuccessfullyToastTitle: 'containerCreatedSuccessfullyToastTitle',
  containerUpdatedSuccessfullyToastTitle: 'containerUpdatedSuccessfullyToastTitle',

  orderUploadSourceStockLocationNotFound: 'orderUploadSourceStockLocationNotFound',
  orderUploadDestinationStockLocationNotFound: 'orderUploadDestinationStockLocationNotFound',
  orderUploadSourceBinNotFound: 'orderUploadSourceBinNotFound',
  orderUploadDestinationBinNotFound: 'orderUploadDestinationBinNotFound',
  orderUploadProductMasterDataNotFound: 'orderUploadProductMasterDataNotFound',
  orderUploadLotNotFound: 'orderUploadLotNotFound',
  orderUploadContactNotFound: 'orderUploadContactNotFound',
  orderUploadContactLocationNotFound: 'orderUploadContactLocationNotFound',

  orderUploadOrderNumberMissing: 'orderUploadOrderNumberMissing',
  orderUploadOrderTypeMissing: 'orderUploadOrderTypeMissing',
  orderUploadProductNumberMissing: 'orderUploadProductNumberMissing',
  orderUploadQuantityMissing: 'orderUploadQuantityMissing',
  orderUploadDestinationStockLocationMissing: 'orderUploadDestinationStockLocationMissing',
  orderUploadSourceStockLocationMissing: 'orderUploadSourceStockLocationMissing',
  orderUploadCustomFieldMissing: 'orderUploadCustomFieldMissing',

  orderUploadInvalidType: 'orderUploadInvalidType',
  orderUploadInvalidStatus: 'orderUploadInvalidStatus',
  orderUploadInvalidQuantity: 'orderUploadInvalidQuantity',
  orderUploadInvalidFromBin: 'orderUploadInvalidFromBin',
  orderUploadInvalidToBin: 'orderUploadInvalidToBin',

  cannotCreateQuickTaskForStockLocationWithoutBins: 'cannotCreateQuickTaskForStockLocationWithoutBins',
  createQuickTask: 'createQuickTask',
  quickCountsAreDisabledInYourCompany: 'quickCountsAreDisabledInYourCompany',
  taskQuickCountFeatureToggleTitle: 'taskQuickCountFeatureToggleTitle',
  taskQuickCountFeatureToggleExplanation: 'taskQuickCountFeatureToggleExplanation',
  exportConfigurationPaneSubtitle: 'exportConfigurationPaneSubtitle',
  productTransactionProcessedSuccessfullyToastTitle: 'productTransactionProcessedSuccessfullyToastTitle',
  availableQty: 'availableQty',

  refillLocation: 'refillLocation',
  completePicking: 'completePicking',
  completePickingValidation: 'completePickingValidation',
  processProductTransactionUnableToProcessPickedTransactionWhilePickingNotCompleted:
    'processProductTransactionUnableToProcessPickedTransactionWhilePickingNotCompleted', // 'Cannot complete a picked transaction while the picking process is still ongoing'
  unableToRemoveUserWithAssets: 'unableToRemoveUserWithAssets',
  unableToRemoveUserWithOpenAssetTransactions: 'unableToRemoveUserWithOpenAssetTransactions',
  createContainerScreenTitle: 'createContainerScreenTitle',
  createContainerScreenSubtitle: 'createContainerScreenSubtitle',

  moveContainerWarningTitleOnlyChildContainers: 'moveContainerWarningTitleOnlyChildContainers',
  moveContainerWarningTitleOnlyChildProducts: 'moveContainerWarningTitleOnlyChildProducts',
  moveContainerWarningTitleChildContainersAndProducts: 'moveContainerWarningTitleChildContainersAndProducts',

  moveContainerWarningBodyOnlyChildContainers: 'moveContainerWarningBodyOnlyChildContainers',
  moveContainerWarningBodyOnlyChildProducts: 'moveContainerWarningBodyOnlyChildProducts',
  moveContainerWarningBodyChildContainersAndProducts: 'moveContainerWarningBodyChildContainersAndProducts',
  wasYesterday: 'wasYesterday',
  wasXDaysAgo: 'wasXDaysAgo',
  isInXDays: 'isInXDays',

  binX: 'binX',
  containerX: 'containerX',
  lotX: 'lotX',
  orderX: 'orderX',
  productReferenceX: 'productReferenceX',
  userX: 'userX',
  stockLocationX: 'stockLocationX',

  binDateCustomFieldAlertBody: 'binDateCustomFieldAlertBody',
  productMasterDataDateCustomFieldAlertBody: 'productMasterDataDateCustomFieldAlertBody',
  containerDateCustomFieldAlertBody: 'containerDateCustomFieldAlertBody',
  lotDateCustomFieldAlertBody: 'lotDateCustomFieldAlertBody',
  stockLocationDateCustomFieldAlertBody: 'stockLocationDateCustomFieldAlertBody',
  orderDateCustomFieldAlertBody: 'orderDateCustomFieldAlertBody',
  companyRoleDateCustomFieldAlertBody: 'companyRoleDateCustomFieldAlertBody',
  assetDateCustomFieldAlertBody: 'assetDateCustomFieldAlertBody',
  productTransactionDateCustomFieldAlertBody: 'productTransactionDateCustomFieldAlertBody',
  productDateCustomFieldAlertBody: 'productDateCustomFieldAlertBody',

  orderProductTransactionForProductIdentifierString: 'orderProductTransactionForProductIdentifierString',
  orderProductTransactionForContainerIdentifierString: 'orderProductTransactionForContainerIdentifierString',
  assetAssignedToUserIdentifierString: 'assetAssignedToUserIdentifierString',
  unassignedAssetIdentifierString: 'unassignedAssetIdentifierString',

  selectCustomField: 'selectCustomField',
  createTriggerEntityTypePaneWhenShouldYouBeNotified: 'createTriggerEntityTypePaneWhenShouldYouBeNotified',
  triggerSettingsScreenTitle: 'triggerSettingsScreenTitle',
  triggerSettingsScreenSubtitle: 'triggerSettingsScreenSubtitle',
  before: 'before',
  after: 'after',
  dayOf: 'dayOf',
  scanFeatureToggleTitle: 'scanFeatureToggleTitle',
  scanFeatureToggleExplanation: 'scanFeatureToggleExplanation',
  scanFeatureToggleInformation: 'scanFeatureToggleInformation',
  scanHandleGS1ProductNumberSeparatelyFeatureToggleTitle: 'scanHandleGS1ProductNumberSeparatelyFeatureToggleTitle',
  scanHandleGS1ProductNumberSeparatelyFeatureToggleExplanation:
    'scanHandleGS1ProductNumberSeparatelyFeatureToggleExplanation',
  scanHandleGS1LotSeparatelyFeatureToggleTitle: 'scanHandleGS1LotSeparatelyFeatureToggleTitle',
  scanHandleGS1LotSeparatelyFeatureToggleExplanation: 'scanHandleGS1LotSeparatelyFeatureToggleExplanation',
  scanIgnoreGS1LotFeatureToggleTitle: 'scanIgnoreGS1LotFeatureToggleTitle',
  scanIgnoreGS1LotFeatureToggleExplanation: 'scanIgnoreGS1LotFeatureToggleExplanation',

  label: 'label',
  labelAdd: 'labelAdd',
  labelCreate: 'labelCreate',
  labelScreenTitle: 'labelScreenTitle',
  labelScreenSubtitle: 'labelScreenSubtitle',
  labelAddedSuccessfullyToastTitle: 'labelAddedSuccessfullyToastTitle',

  errorOccurred: 'errorOccurred',
  unknownLanguage: 'unknownLanguage',

  orderByTaskCreatedSuccessfullyToastTitle: 'orderByTaskCreatedSuccessfullyToastTitle',
  stockUpdatedSuccessfullyToastTitle: 'stockUpdatedSuccessfullyToastTitle',

  containerMarkedAsMissing: 'containerMarkedAsMissing',
  found: 'found',
  createContainerTaskProductTitle: 'createContainerTaskProductTitle',
  createContainerTaskProductSubtitle: 'createContainerTaskProductSubtitle',
  taskProcessContainerCountAsMissingInfo: 'taskProcessContainerCountAsMissingInfo',
  taskProcessContainerInputCountChildrenInput: 'taskProcessContainerInputCountChildrenInput',
  taskProcessContainerExpectedElsewhereInfo: 'taskProcessContainerExpectedElsewhereInfo',
  taskProcessContainerInputMissingTitle: 'taskProcessContainerInputMissingTitle',
  taskProcessContainerInputUpdateTitle: 'taskProcessContainerInputUpdateTitle',
  taskProcessContainerInputAdditionalTitle: 'taskProcessContainerInputAdditionalTitle',
  taskProcessContainerInputCountTitle: 'taskProcessContainerInputCountTitle',
  taskProcessContainerInputMissingSubtitle: 'taskProcessContainerInputMissingSubtitle',
  taskProcessContainerInputUpdateSubtitle: 'taskProcessContainerInputUpdateSubtitle',
  taskProcessContainerInputAdditionalSubtitle: 'taskProcessContainerInputAdditionalSubtitle',

  session: 'session',
  stockLocationSettingsMapScreenTitle: 'stockLocationSettingsMapScreenTitle',
  stockLocationSettingsMapScreenSubtitle: 'stockLocationSettingsMapScreenSubtitle',

  endMobileStockLocationSessionSuccessfullyToastTitle: 'endMobileStockLocationSessionSuccessfullyToastTitle',
  endMobileStockLocationSessionModalTitle: 'endMobileStockLocationSessionModalTitle',
  endMobileStockLocationSessionModalSubtitle: 'endMobileStockLocationSessionModalSubtitle',
  endSession: 'endSession',
  stockLocationMobileInputTooltip: 'stockLocationMobileInputTooltip',
  stockLocationMobileInputLabel: 'stockLocationMobileInputLabel',
  sessionStartedSuccessfullyToastTitle: 'sessionStartedSuccessfullyToastTitle',
  leaveCompany: 'leaveCompany',
  containerTypeDeletedSuccessfullyToastTitle: 'containerTypeDeletedSuccessfullyToastTitle',

  // Process Product Transaction Errors
  processProductTransactionStatusError: 'processProductTransactionStatusError',
  processProductTransactionProcessTypeError: 'processProductTransactionProcessTypeError',
  processProductTransactionNotFoundError: 'processProductTransactionNotFoundError',
  processProductTransactionPickingIncompleteError: 'processProductTransactionPickingIncompleteError',

  processProductTransactionProductMasterDataMissingError: 'processProductTransactionProductMasterDataMissingError',
  processProductTransactionProductMasterDataNotFoundError: 'processProductTransactionProductMasterDataNotFoundError',

  processProductTransactionOrderMissingError: 'processProductTransactionOrderMissingError',
  processProductTransactionOrderNotFoundError: 'processProductTransactionOrderNotFoundError',

  processProductTransactionDestinationContainerNotFoundError:
    'processProductTransactionDestinationContainerNotFoundError',
  processProductTransactionSourceContainerNotFoundError: 'processProductTransactionSourceContainerNotFoundError',

  processProductTransactionContainersFeatureNotEnabledError:
    'processProductTransactionContainersFeatureNotEnabledError',
  processProductTransactionContainerInSystemLocationError: 'processProductTransactionContainerInSystemLocationError',
  processProductTransactionContainerCircularReferenceError: 'processProductTransactionContainerCircularReferenceError',
  processProductTransactionContainerNotEmptyError: 'processProductTransactionContainerNotEmptyError',

  processProductTransactionDestinationStockLocationMissingError:
    'processProductTransactionDestinationStockLocationMissingError',
  processProductTransactionDestinationStockLocationNotFoundError:
    'processProductTransactionDestinationStockLocationNotFoundError',

  processProductTransactionSourceStockLocationMissingError: 'processProductTransactionSourceStockLocationMissingError',
  processProductTransactionSourceStockLocationNotFoundError:
    'processProductTransactionSourceStockLocationNotFoundError',

  processProductTransactionDestinationBinMissingError: 'processProductTransactionDestinationBinMissingError',
  processProductTransactionDestinationBinNotFoundError: 'processProductTransactionDestinationBinNotFoundError',
  processProductTransactionDestinationBinInboundNotAllowedError:
    'processProductTransactionDestinationBinInboundNotAllowedError',
  processProductTransactionDestinationBinConstraintMismatchError:
    'processProductTransactionDestinationBinConstraintMismatchError',

  processProductTransactionSourceBinMissingError: 'processProductTransactionSourceBinMissingError',
  processProductTransactionSourceBinNotFoundError: 'processProductTransactionSourceBinNotFoundError',
  processProductTransactionSourceBinInboundNotAllowedError: 'processProductTransactionSourceBinInboundNotAllowedError',

  processProductTransactionDestinationBinStatusNotFoundError:
    'processProductTransactionDestinationBinStatusNotFoundError',
  processProductTransactionSourceBinStatusNotFoundError: 'processProductTransactionSourceBinStatusNotFoundError',

  processProductTransactionLotNotAllowedError: 'processProductTransactionLotNotAllowedError',
  processProductTransactionLotNotFoundError: 'processProductTransactionLotNotFoundError',
  processProductTransactionLotMissingError: 'processProductTransactionLotMissingError',
  processProductTransactionLotsFeatureNotEnabledError: 'processProductTransactionLotsFeatureNotEnabledError',

  processProductTransactionLPNNotAllowedError: 'processProductTransactionLPNNotAllowedError',
  processProductTransactionLPNMissingError: 'processProductTransactionLPNMissingError',

  processProductTransactionSerialNotAllowedError: 'processProductTransactionSerialNotAllowedError',
  processProductTransactionSerialMissingError: 'processProductTransactionSerialMissingError',
  processProductTransactionSerialQuantityError: 'processProductTransactionSerialQuantityError',
  processProductTransactionSerialAlreadyExistsError: 'processProductTransactionSerialAlreadyExistsError',

  processProductTransactionQuantityMissingError: 'processProductTransactionQuantityMissingError',
  processProductTransactionProcessedQuantityMissingError: 'processProductTransactionProcessedQuantityMissingError',
  processProductTransactionProcessedQuantityExceedsError: 'processProductTransactionProcessedQuantityExceedsError',
  processProductTransactionQuantityMustBePositiveError: 'processProductTransactionQuantityMustBePositiveError',
  processProductTransactionProcessedQuantityPartialNotAllowedError:
    'processProductTransactionProcessedQuantityPartialNotAllowedError',

  processProductTransactionLotProductMasterDataMismatchError:
    'processProductTransactionLotProductMasterDataMismatchError',
  processProductTransactionDestinationBinStockLocationMismatchError:
    'processProductTransactionDestinationBinStockLocationMismatchError',
  processProductTransactionSourceBinStockLocationMismatchError:
    'processProductTransactionSourceBinStockLocationMismatchError',
  processProductTransactionOrderStockLocationMismatchError: 'processProductTransactionOrderStockLocationMismatchError',
  processProductTransactionDestinationContainerBinMismatchError:
    'processProductTransactionDestinationContainerBinMismatchError',
  processProductTransactionSourceContainerBinMismatchError: 'processProductTransactionSourceContainerBinMismatchError',
  processProductTransactionDestinationContainerStockLocationMismatchError:
    'processProductTransactionDestinationContainerStockLocationMismatchError',
  processProductTransactionSourceContainerStockLocationMismatchError:
    'processProductTransactionSourceContainerStockLocationMismatchError',

  processProductTransactionProductMasterDataOrContainerMissingError:
    'processProductTransactionProductMasterDataOrContainerMissingError',

  processProductTransactionProductMasterDataIdChangedError: 'processProductTransactionProductMasterDataIdChangedError',
  processProductTransactionToStockLocationIdChangedError: 'processProductTransactionToStockLocationIdChangedError',
  processProductTransactionFromStockLocationIdChangedError: 'processProductTransactionFromStockLocationIdChangedError',
  processProductTransactionContainerIdChangedError: 'processProductTransactionContainerIdChangedError',
  processProductTransactionQuantityChangedError: 'processProductTransactionQuantityChangedError',
  processProductTransactionParentIdChangedError: 'processProductTransactionParentIdChangedError',
  processProductTransactionParentTypeChangedError: 'processProductTransactionParentTypeChangedError',

  processProductTransactionKitTemplateMissingError: 'processProductTransactionKitTemplateMissingError',
  processProductTransactionKitTemplateNotFoundError: 'processProductTransactionKitTemplateNotFoundError',
  processProductTransactionKitTemplateProductMasterDataMismatchError:
    'processProductTransactionKitTemplateProductMasterDataMismatchError',

  processProductTransactionKitIdMissingError: 'processProductTransactionKitIdMissingError',
  processProductTransactionKitNotFoundError: 'processProductTransactionKitNotFoundError',
  processProductTransactionKitIdentifierAlreadyUsedError: 'processProductTransactionKitIdentifierAlreadyUsedError',
  processProductTransactionKitParentProductNotFoundError: 'processProductTransactionKitParentProductNotFoundError',
  processProductTransactionKitParentProductBinMismatchError:
    'processProductTransactionKitParentProductBinMismatchError',
  processProductTransactionKitQuantityExceededError: 'processProductTransactionKitQuantityExceededError',
  processProductTransactionKitProductMismatchError: 'processProductTransactionKitProductMismatchError',

  processProductTransactionProductNotFoundError: 'processProductTransactionProductNotFoundError',

  processProductTransactionInsufficientProductQuantityError:
    'processProductTransactionInsufficientProductQuantityError',

  // Kit Template Errors
  kitTemplateProductsMissingError: 'kitTemplateProductsMissingError',
  kitTemplateProductMasterDataNotFoundError: 'kitTemplateProductMasterDataNotFoundError',
  kitTemplateProductMasterDataIdChangedError: 'kitTemplateProductMasterDataIdChangedError',
  kitTemplateProductMasterDataNotKitManagedError: 'kitTemplateProductMasterDataNotKitManagedError',

  kitTemplateProductProductMasterDataNotFoundError: 'kitTemplateProductProductMasterDataNotFoundError',
  kitTemplateProductQuantityError: 'kitTemplateProductQuantityError',
  kitTemplateProductAlreadyExistsError: 'kitTemplateProductAlreadyExistsError',
  kitTemplateProductCircularReferenceError: 'kitTemplateProductCircularReferenceError',
  kitTemplateProductKitManagedError: 'kitTemplateProductKitManagedError',

  // Kit Template
  kitTemplate: 'kitTemplate',
  kitTemplateFilter: 'kitTemplateFilter',
  kitTemplateAdd: 'kitTemplateAdd',
  kitTemplateCreateTitle: 'kitTemplateCreateTitle',
  kitTemplateUpdateTitle: 'kitTemplateUpdateTitle',
  kitTemplateDeleteTitle: 'kitTemplateDeleteTitle',
  kitTemplateDeleteSubtitle: 'kitTemplateDeleteSubtitle',
  kitTemplateDelete: 'kitTemplateDelete',
  kitTemplateCreatedSuccessfully: 'kitTemplateCreatedSuccessfully',
  kitTemplateUpdatedSuccessfully: 'kitTemplateUpdatedSuccessfully',
  kitTemplateDeletedSuccessfully: 'kitTemplateDeletedSuccessfully',

  // Kit Errors
  kitTemplateIdChangedError: 'kitTemplateIdChangedError',

  kit: 'kit',
  kitComplete: 'kitComplete',
  kitScreenTitle: 'kitScreenTitle',
  kitScreenSubtitle: 'kitScreenSubtitle',
  kitProduct: 'kitProduct',
  kitProductFilter: 'kitProductFilter',
  kitProductCreate: 'kitProductCreate',
  kitProductCreatedSuccessfullyToastTitle: 'kitProductCreatedSuccessfullyToastTitle',
  kitting: 'kitting',

  orderUnableToAddProductToExternalOrderError: 'orderUnableToAddProductToExternalOrderError',

  stockKeepingUnit: 'stockKeepingUnit',

  driver: 'driver',
  lastUpdate: 'lastUpdate',
  lastDriver: 'lastDriver',
  source: 'source',
  destination: 'destination',
  reference: 'reference',
  manual: 'manual',
  addCustomField: 'addCustomField',
  endedAt: 'endedAt',

  link: 'link',
  linkCompany: 'linkCompany',
  activity: 'activity',
  partner: 'partner',
  partnerPortal: 'partnerPortal',
  productCount: 'productCount',
  assetTransaction: 'assetTransaction',
  numberOfActions: 'numberOfActions',
  selectCompany: 'selectCompany',
  filterCompany: 'filterCompany',
  taskProduct: 'taskProduct',
  assetMetrics: 'assetMetrics',
  taskCountContainersFeatureToggleTitle: 'taskCountContainersFeatureToggleTitle',
  taskCountContainersFeatureToggleExplanation: 'taskCountContainersFeatureToggleExplanation',
  scanRequiredOrderWarning: 'scanRequiredOrderWarning',
  integrationDeletedSuccessfullyToastTitle: 'integrationDeletedSuccessfullyToastTitle',

  teamleaderCorrectionOrder: 'teamleaderCorrectionOrder',
  teamleaderFetchProduct: 'teamleaderFetchProduct',
  teamleaderFetchContact: 'teamleaderFetchContact',
  teamleaderFetchReferenceData: 'teamleaderFetchReferenceData',
  teamleaderCreateCustomField: 'teamleaderCreateCustomField',
  teamleaderCreateStockLocation: 'teamleaderCreateStockLocation',
  teamleaderCreateBin: 'teamleaderCreateBin',
  teamleaderCreateWebhook: 'teamleaderCreateWebhook',

  address: 'address',
  phone: 'phone',

  userSettingsManagementVerifyEmailSentToastTitle: 'userSettingsManagementVerifyEmailSentToastTitle',
  userSettingsManagementVerifyUserEmailTitle: 'userSettingsManagementVerifyUserEmailTitle',
  userSettingsManagementVerifyEmailAlreadyVerified: 'userSettingsManagementVerifyEmailAlreadyVerified',
  userSettingsManagementVerifyUserEmailRequestAction: 'userSettingsManagementVerifyUserEmailRequestAction',
  userSettingsManagementResetUserPasswordEmailSentToastTitle:
    'userSettingsManagementResetUserPasswordEmailSentToastTitle',
  userSettingsManagementResetUserPasswordTitle: 'userSettingsManagementResetUserPasswordTitle',
  userSettingsManagementResetUserPasswordSubtitle: 'userSettingsManagementResetUserPasswordSubtitle',
  userSettingsManagementTitle: 'userSettingsManagementTitle',
  userSettingsManagementResetUserPasswordRequestAction: 'userSettingsManagementResetUserPasswordRequestAction',

  pdfTemplate: 'pdfTemplate',
  noPdfTemplateYetTitle: 'noPdfTemplateYetTitle',

  configurationName: 'configurationName',
  configurationNamePlaceholder: 'configurationNamePlaceholder',
  format: 'format',
  horizontalMargin: 'horizontalMargin',
  verticalMargin: 'verticalMargin',

  fieldMissingError: 'fieldMissingError',
  fieldTypeError: 'fieldTypeError',

  allTasksCompleted: 'allTasksCompleted',
  selectBarcodeExportConfiguration: 'selectBarcodeExportConfiguration',
  generateBarcode: 'generateBarcode',
  mobileStockLocationSessionLocationPermissionDescription: 'mobileStockLocationSessionLocationPermissionDescription',
  files: 'files',
  ean: 'ean',
  containerIdentifier: 'containerIdentifier',
  pdf: 'pdf',

  // Added for product export fields (but these are not all)
  containerName: 'containerName',
  sourceContainerIdentifier: 'sourceContainerIdentifier',
  destinationContainerIdentifier: 'destinationContainerIdentifier',
  sourceBinName: 'sourceBinName',
  destinationBinName: 'destinationBinName',
  parentType: 'parentType',

  // Added for task export fields (but these are not all)
  countedAt: 'countedAt',
  countedBy: 'countedBy',
  assignedBy: 'assignedBy',
  countedQuantity: 'countedQuantity',
  quantityDifference: 'quantityDifference',
  discrepancy: 'discrepancy',
  lotExpiryDate: 'lotExpiryDate',
  inContainer: 'inContainer',
  kitManaged: 'kitManaged',

  // Added for reorder rule export fields (but these are not all)
  stockLocationAggregateType: 'stockLocationAggregateType',

  configureLabel: 'configureLabel',

  stockTransfer: 'stockTransfer',

  useCustomValue: 'useCustomValue',
  labelRemovedSuccessfullyToastTitle: 'labelRemovedSuccessfullyToastTitle',

  kitKitFeatureToggleTitle: 'kitKitFeatureToggleTitle',
  kitKitFeatureToggleExplanation: 'kitKitFeatureToggleExplanation',
  kitRefillKitsFeatureToggleTitle: 'kitRefillKitsFeatureToggleTitle',
  kitRefillKitsFeatureToggleExplanation: 'kitRefillKitsFeatureToggleExplanation',

  deleteBinModalTitle: 'deleteBinModalTitle',
  deleteBinModalPrimaryText: 'deleteBinModalPrimaryText',
  deleteBinModalWarningText: 'deleteBinModalWarningText',

  containerDeletedSuccessfullyToastTitle: 'containerDeletedSuccessfullyToastTitle',
  deleteContainerModalTitle: 'deleteContainerModalTitle',
  deleteContainerModalSubtitle: 'deleteContainerModalSubtitle',
  deleteContainer: 'deleteContainer',

  addLotColumn: 'addLotColumn',
  companyStatus: 'companyStatus',
} as const;

export type TranslationKey = (typeof TranslationKey)[keyof typeof TranslationKey];
